import Vue from 'vue'
import VueI18n from 'vue-i18n'

import store from '@/store'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'es',
    fallbackLocale: 'en',
    messages: {
        es: {
            //Login
            intrare_empresa: 'Intrare Empresa',
            mensaje_login: 'Acceso al Sistema',
            ingresar: 'Ingresar',
            mensaje_olvidar_contrasena: '¿Olvidaste tu contraseña?',
            mensaje_link_restablecer1: 'Da click',
            mensaje_link_restablecer2: 'aquí',
            mensaje_link_restablecer3: 'para restablecerla.',
            msg_password_reset: 'Ingrese su E-mail y a continuación le enviaremos una contraseña temporal.',
            msg_password_reset_done1: 'Le hemos enviado una contraseña temporal por E-Mail.',
            msg_password_reset_done2: '¡Deberías recibir el correo en breve!',
            Bienvenido: 'Bienvenido',
            agregar: 'Agregar',
            asociar: 'Asociar',
            modificar: 'Modificar',
            modificar_hora: 'Modificar Hora',
            cerrar: 'Cerrar',
            Buscar: 'Buscar',
            ningun_resultado_1: 'La búsqueda de',
            ningun_resultado_2: 'no tiene coincidencias',
            prep_de: 'de',
            filas_por_pagina: 'Filas por Página',
            todos: 'Todos',
            region: 'es-MX',
            Ayuda: 'Centro de Ayuda',
            AdministradorParque: 'Administrador del Parque Industrial',
            Administrador: 'Administrador',
            Vigilante_entrada: 'Vigilante/Entrada',
            Vigilante_salida: 'Vigilante/Salida',
            Vigilante: 'Vigilante',
            Vigilante_Parque: 'Vigilante Parque Industrial',
            Guardia: 'Guardia',
            SuperAdministrador: 'SuperAdministrador',
            security_admin: 'Administrador de Seguridad',
            //Menú Empleado
            Historial_Invitaciones_Enviadas: 'Historial de Invitaciones Enviadas',
            Historial_Invitaciones_Recibidas: 'Historial de Invitaciones Recibidas',
            Historial_Accesos: 'Historial de accesos con código',
            Historial: 'Historial',
            Historial_Empleados: 'Historial Empleados',
            //Menú Vigilante
            bitacora: 'Bitácora',
            type_of_access: 'Tipo de acceso',
            entradas_salidas: 'Acceso/Salida',
            acceso_sin_codigo: 'Acceso sin Código',
            acceso_con_codigo: 'Acceso con Código',
            entrada_salida_no_code: 'Acceso sin Código',
            historial_accesos_sin_codigo: 'Historial de accesos sin código',
            access_log: 'Historial de accesos',
            //Menú Administrador
            Invitaciones: 'Invitaciones',
            Accesos: 'Accesos',
            firma_salida: 'Firmar Pase de Salida',
            firmado: 'Firmado',
            no_firmado: 'No Firmado',
            firmar: 'Firmar',
            mensaje_pase_salida_firmado: 'Pase de salida firmado con éxito.',
            no_registros_pase_salida: 'No hay registros de acceso.',
            mensaje_pase_salida: 'Personas dentro de la Empresa',
            Casetas: 'Casetas',
            Vigilantes: 'Vigilantes',
            boton_emergencia: 'Botón de Emergencia',
            emergencia: 'Emergencia',
            evacuacion: 'Evacuación',
            //Empleados
            Empleados: 'Empleados',
            AnadirEmpleado: 'Añadir Empleado',
            mensaje_empleado_alta: 'Empleado dado de Alta Correctamente.',
            mensaje_empleado_modificado: 'Empleado Modificado Correctamente.',
            Area: 'Área',
            section_name: 'Nombre de la Sección',
            section: 'Sección',
            add_section: 'Añadir Sección',
            msg_section_added: 'Sección agregada correctamente.',
            msg_section_updated: 'Sección actualizada correctamente.',
            msg_section_deleted: 'Sección eliminada correctamente.',
            msg_delete_section: '¿Estás seguro de que quieres eliminar la sección?',
            espacios: 'Espacios',
            Nombre: 'Nombre(s)',
            Apellido: 'Apellido(s)',
            Invitacion: 'Invitación',
            puede_enviar: 'Puede enviar invitaciones',
            puede_enviar2: 'Puede enviar invitaciones',
            extension: 'Extensión',
            ine_frente: 'Imagen frente Identificación',
            foto_ine: 'Identificación Oficial con Foto (INE, Licencia de Conducir)',
            ine_atras: 'Imagen atrás Identificación',
            celular: 'Celular',
            celular_invitado: 'Celular del invitado',
            password: 'Contraseña',
            current_password: 'Contraseña Actual',
            new_password: 'Contraseña Nueva',
            password_confirm: 'Confirmar Contraseña Nueva',
            password_confirm2: 'Confirmar Contraseña',
            change_password: 'Cambiar Contraseña',
            Activo: 'Activo',
            //Casetas
            AnadirCaseta: 'Añadir Caseta',
            mensaje_caseta_alta: 'Caseta Agregada Correctamente',
            mensaje_caseta_modificada: 'Caseta Modificada Correctamente.',
            mensaje_caseta_eliminada: 'Caseta Eliminada Correctamente.',
            //Vigilantes
            anadir_vigilante: 'Añadir Vigilante',
            mensaje_vigilante_alta: 'Vigilante Agregado Correctamente.',
            mensaje_vigilante_modificado: 'Vigilante Modificado Correctamente.',
            mostrar_info_invit: 'Mostrar información de la invitación',
            info_invitation: 'INFORMACIÓN DE LA INVITACIÓN',
            info_invitado: 'INFORMACIÓN DEL INVITADO',
            info_contractor: 'INFORMACIÓN DEL CONTRATISTA',
            info_anfitrion: 'INFORMACIÓN DEL ANFITRIÓN',
            datos_coche: 'Datos del automóvil',
            guardar: 'Guardar',
            acceso: 'Acceso',
            registrar_entrada: 'Registrar entrada',
            registrar_salida: 'Registrar salida',
            form_salida: 'Formulario Salida',
            mensaje_alta_acceso_in: 'Acceso Registrado Correctamente.',
            mensaje_alta_acceso_out: 'Salida Registrada Correctamente.',
            canceled_invitation: '¡INVITACIÓN CANCELADA!',
            msg_canceled_invitation_offline: 'Esta invitación ha sido cancelada por el Anfitrión.',
            msg_canceled_invitation: '¡ACCESO DENEGADO! .Esta invitación ha sido cancelada por el Anfitrión.',
            mensaje_qr_no_valido: '!ACCESO DENEGADO¡. Código QR, no válido.',
            mensaje_qr_no_parque_empresa: '!ACCESO DENEGADO¡. La invitación no coincide con el Parque Industrial o la Empresa.',
            mensaje_qr_no_vigente: '!ACCESO DENEGADO¡. La invitación aún no es vigente.',
            mensaje_qr_expirado: '!ACCESO DENEGADO¡. La invitación ha expirado.',
            mensaje_qr_no_confirmado: '!ACCESO DENEGADO¡. El Invitado no ha confirmado la invitación.',
            mensaje_qr_no_empresa: '!ACCESO DENEGADO¡. La invitación no corresponde a la Empresa.',
            mensaje_qr_vetado: '!ACCESO DENEGADO¡. ',
            mensaje_acceso_completo: 'Ya se completó el Acceso con la Invitación Correspondiente.',
            mensaje_alta_acceso_without: 'Acceso Registrado Correctamente.',
            mensaje_alta_usuario: 'Usuario registrado correctamente.',
            //Invitación
            Empleado: 'Empleado',
            fecha_hora: 'Fecha y Hora de la Invitación',
            fecha_inv: 'Fecha de la Invitación',
            fecha_expiracion: 'Fecha de Expiración',
            fecha_envio: 'Fecha de Envío',
            hora_inv: 'Hora de la Invitación',
            Asunto: 'Asunto',
            placeholder_asunto: 'Escribe el Asunto de la Invitación',
            mensaje_equipo: 'Equipo de seguridad requerido:',
            equipo_seguridad: 'Equipo',
            mensaje_vehiculo: '¿Acceso con vehículo?',
            enviar_codigo: 'Enviar Código',
            Notas: 'Notas',
            placeholder_notas: 'Escribe Notas extras para la Invitación',
            Si: 'Si',
            invitación_referido: 'Invitación Referido',
            ininvitación_normal: 'Invitación',
            mensaje_invitacion_alta: 'Invitación Enviada Correctamente.',
            //Empresas
            Empresas: 'Empresas',
            AnadirEmpresa: 'Añadir Empresa',
            AsociarEmpresa: 'Asociar Empresa',
            telefono: 'Teléfono',
            logotipo: 'Logotipo',
            pagina_web: 'Página Web',
            clasificacion: 'Clasificación',
            latitud: 'Latitud',
            longitud: 'Longitud',
            url_mapa: 'URL del Mapa',
            vigencia: 'Vigencia',
            Parque: 'Parque',
            mensaje_empresa_alta: 'Empresa dada de Alta Correctamente.',
            mensaje_empresa_modificado: 'Empresa Modificada Correctamente.',
            mensaje_empresa_asociada_eliminada: 'Empresa Asociada Eliminada Correctamente.',
            mensaje_empresa_asociada_alta: 'Empresa Asociada Correctamente.',
            //Parques
            Parques: 'Parques',
            Parques_Industriales: 'Parques Industriales',
            AnadirParque: 'Añadir Parque',
            nombre: 'Nombre',
            direccion: 'Dirección',
            mensaje_parque_alta: 'Parque dado de alta Correctamente.',
            mensaje_parque_modificado: 'Parque Modificado Correctamente.',
            //Administradores
            Administradores: 'Administradores',
            anadir_administrador: 'Añadir Administrador',
            Empresa: 'Empresa',
            company_name: 'Nombre de la Empresa',
            data_company: 'Datos Administrador de Empresa',
            mensaje_administrador_alta: 'Administrador dado de Alta Correctamente.',
            mensaje_administrador_modificado: 'Administrador Modificado Correctamente.',
            mensaje_administrador_eliminado: 'Administrador Eliminado Correctamente.',
            //Áreas
            Areas: 'Áreas',
            anadir_area: 'Añadir Área',
            mensaje_areas_alta: 'Área Agregada Correctamente.',
            mensaje_areas_modificado: 'Área Modificada Correctamente.',
            //Contactos
            contactos: 'Contactos',
            anadir_contacto: 'Añadir Contacto',
            mensaje_contacto_alta: 'Contacto Agregado Correctamente.',
            mensaje_contacto_modificado: 'Contacto Modificado Correctamente.',
            //Grupos
            grupos: 'Grupos',
            anadir_grupo: 'Añadir Grupo',
            mensaje_grupo_alta: 'Grupo Agregado Correctamente.',
            mensaje_grupo_modificado: 'Grupo Modificado Correctamente.',
            mensaje_grupo_delete: 'Grupo Eliminado Correctamente',
            eliminar: 'Eliminar',
            //ContactosXGrupo
            contactosXgrupo: 'Contactos Por Grupo',
            mensaje_contactoXgrupo_alta: 'Contacto Agregado Correctamente al Grupo.',
            mensaje_contactoXgrupo_delete: 'Contacto Eliminado del Grupo Correctamente.',
            //Invitaciones
            Filtrar: 'Filtrar',
            select_fecha: 'Seleccionar fecha:',
            mostrando_inv_dia: 'Mostrando invitaciones del día:',
            mostrando_historial_dia: 'Mostrando Historial filtrado por:',
            msg_people_inside_company: 'Personas Dentro de la Empresa para la Fecha:',
            Fecha: 'Fecha',
            Fecha_ini: 'Fecha Inicial',
            Fecha_fin: 'Fecha Final',
            Visitante: 'Visitante',
            Visitantes: 'Visitante(s)',
            Anfitrion: 'Anfitrión',
            hora_llegada: 'Hora de Llegada',
            hora_acceso: 'Hora de Acceso',
            hora_salida: 'Hora de Salida',
            Tipo: 'Tipo',
            no_registros_invit: 'No hay registros de invitaciones para ese día.',
            no_records_waiting_room: 'Aún no hay nadie en la Sala de espera.',
            no_registros_proveedores: 'No hay registros de Proveedores.',
            //Accesos
            no_registros_accesos: 'No hay registros de accesos para ese día.',
            //Accesos/Salidas
            mensaje_acercar_QR: 'Acerca el código QR a la cámara.',
            Leer: 'Leer',
            enviar: 'Enviar',
            selecciona_caseta: 'Selecciona una Caseta',
            aceptar: 'Aceptar',
            no_resultados: 'Ningún Resultado',
            page_not_found: 'Página No Encontrada.!!!',
            page_not_found1: 'La URL',
            page_not_found2: 'solicitada no se encontró en este servidor.',
            inicio: 'Inicio',
            atras: 'Atrás',
            preregistro: 'Preregistro',
            registro_exito: 'Datos Enviados Correctamente',
            msj_cerrar_pagina: 'Tus datos están en proceso de Validación.',
            msj2_cerrar_pagina: 'Una vez validados se te notificará por SMS y/o E-Mail',
            msj_cerrar_pagina_complemento: ' Puede cerrar esta página.',
            identidad_exito: 'Identidad Confirmada Correctamente',
            identidad_exito2: 'Gracias por Confirmar Identidad',
            identidad_desconocido: 'Invitado No reconocido.',
            identidad_desconocido2: 'En breve se le notificará al invitado para que corrija los datos.',
            pgt_seguro: '¿Está seguro que no conoce al invitado?',
            foto_perfil: 'Foto de Perfil',
            confirmar_identidad: 'Confirmar Identidad',
            msg_know_guest: '¿Reconoce al Invitado?',
            msg_notificacion_anfitrion: 'Se ha enviado una Notificación al Anfitrión.',
            estado: 'Estado',
            waiting_room: 'Sala de Espera',
            adentro: 'Adentro',
            completado: 'Completado',
            pending_authorization: 'Autorización pendiente',
            subir_imagen: 'Subir Imagen',
            update_image: 'Actualizar Imagen',
            qr_code: 'Código QR',
            msg_qr_code: 'Introduce el Código QR',
            invitados: 'Invitado(s)',
            invitados_no_confirmados: 'Registro(s) Pendiente(s)',
            placeholder_invitados: 'Buscar por E-Mail',
            placeholder_invitados2: 'Buscar por nombre/email/celular',
            placeholder_empresas: 'Buscar por Empresa',
            add_new_contact: 'Añadir Nuevo Contacto',
            add_new_employee: 'Añadir Nuevo Empleado',
            invitacion_grupal: 'Invitación Grupal',
            pagina_caduca: 'Esta Página ha Expirado.',
            survey_success: 'Encuesta enviada correctamente.',
            sin_permisos: 'Usted no tiene permiso para realizar esta acción.',
            aviso: 'Aviso',
            cancelar: 'Cancelar',
            detalle: 'Detalle',
            detalle_invit: 'Detalle de la Invitación',
            detalle_invit_recibidas: 'Detalle de la Invitación Recibida',
            detalle_access: 'Detalles del Acceso',
            pendiente: 'Pendiente',
            info_acceso: 'INFORMACIÓN DEL ACCESO',
            fecha_hora_acceso_in: 'Fecha y Hora del Acceso',
            fecha_hora_acceso: 'Fecha y Hora de Acceso',
            fecha_hora_acceso_out: 'Fecha y Hora de Salida',
            pase_salida: 'Pase de Salida',
            confirmar: 'Confirmar',
            email_admin: 'E-Mail del Administrador',
            lbl_invit_empresarial: 'Invitación Empresarial',
            lbl_VIP_invitation: 'Invitación VIP',
            tooltip_vip_invitation: 'La invitación VIP nos habilita la entrada diaria del invitado sin vigencia.',
            lbl_host_company: 'Empresa Anfitrión',
            add_equipo_seguridad: 'Agregar Equipo de Seguridad',
            mensaje_areas_equipo_alta: 'Equipo de Seguridad Agregada Correctamente.',
            mensaje_areas_equipo_update: 'Equipo de Seguridad Modificado Correctamente.',
            mensaje_areas_equipo_delete: 'Equipo de Seguridad Eliminado Correctamente.',
            lbl_invitacion_recurrente: 'Invitación Recurrente',
            Lunes: 'Lunes',
            Martes: 'Martes',
            Miercoles: 'Miércoles',
            Jueves: 'Jueves',
            Viernes: 'Viernes',
            Sabado: 'Sábado',
            Domingo: 'Domingo',
            lbl_selecciona_dias: 'Selecciona los días',
            normal: 'Empresa Normal',
            empresarial: 'Empresarial',
            recurrente: 'Empresa Recurrente',
            parking: 'Estacionamiento',
            msg_eliminar_company_associate: '¿Está seguro de desvincular esta Empresa de su Parque Industrial?',
            msg_eliminar_administrador: '¿Está seguro de eliminar al Administrador?',
            msg_emergencia: '¿Está seguro de enviar el mensaje de Emergencia?',
            msg_eliminar_empleado: '¿Está seguro de eliminar al Empleado?',
            msg_eliminar_ban: '¿Estás segura de quitar la Restricción?',
            msg_eliminar_sala_espera: '¿Está seguro de eliminar el registro de la Sala de Espera?',
            msg_eliminar_vigilante: '¿Está seguro de eliminar al Vigilante?',
            msg_eliminar_invitacion: '¿Está seguro de eliminar la invitación?',
            msg_cancelar_invitacion: '¿Está seguro de cancelar la invitación?',
            msg_eliminar_caseta: '¿Está seguro de eliminar la Caseta?',
            msg_eliminar_invitacion_2: 'Esta acción no se puede deshacer.',
            mensaje_invitacion_delete: 'Invitación Eliminada Correctamente.',
            mensaje_invitacion_canceled: 'Invitación Cancelada Correctamente.',
            mensaje_empleado_delete: 'Empleado Eliminada Correctamente.',
            mensaje_vigilante_delete: 'Vigilante Eliminada Correctamente.',
            dias_validos: 'Días Válidos',
            empresa_procedencia: 'Empresa del Invitado',
            mg_enviado: 'Mensaje Enviado Correctamente',
            lbl_emergencia: 'Aviso: Se enviará un mensaje de Emergencia a todos los invitados dentro de la Empresa.',
            msg: 'Mensaje',
            recortar: 'Recortar',
            recortar_imagen: 'Recortar Imagen',
            frente: 'Frente',
            reverso: 'Atrás',
            msg_no_days: 'Debe de seleccionar al menos un día para continuar con la Invitación.',
            msg_no_days2: 'Debe de seleccionar al menos un día para continuar.',
            cambiar_permisos: 'Cambiar Permisos',
            move_up: 'Usuario -> Empleado',
            move_up_admin: 'Usuario -> Administrador',
            move_up_supplier: 'Usuario -> Administrador de Empresa',
            usuarios: 'Usuarios',
            msg_cambio_permisos: 'Permisos cambiados Correctamente.',
            msg_invitacion_confirmada: 'Invitación Confirmada Correctamente',
            msg_invitation_changed: 'Invitación Modificada Correctamente.',
            asistira: '¿Asistirá?',
            invitacion_rechazada: 'Invitación Rechazada Correctamente.',
            print_name_tag: 'Imprimir Gafete',
            ejemplo: 'Ejemplo: ',
            codigo_pais: 'Código del País',
            cellphone_wrong: 'Número de Celular Incorrecto',
            campany_data: 'Datos de la Empresa',
            manager_data: 'Datos del Administrador',
            employee_data: 'Datos del Empleado',
            paso: 'Paso',
            continuar: 'Continuar',
            msg_cambio_password: 'Contraseña cambiada Correctamente.',
            configuracion: 'Configuración',
            proveedor: 'Administrador',
            empleado_proveedor: 'Empleado',
            proveedores: 'Empresas',
            Anadirproveedor: 'Añadir Empresa',
            enviar_reg_admin_proveedor: 'E-Mail enviado Exitosamente.',
            msg_proveedor_correcto: 'Por favor verifique que sus datos estan correctos. En caso contrario modifíquelos.',
            msg_empresa_proveedor: 'Tu Empresa ahora usa Intrare.',
            msg_empresa_proveedor1: 'Tu Empresa puede reenviar invitaciones,  gestionar áreas y empleados.',
            msg_empresa_proveedor2: 'Revisa tu correo electrónico,  hemos enviado tus credenciales del acceso al Sistema.',
            catalogos: 'Catálogos',
            company_email: 'E-Mail de la Empresa',
            msg_acceso: 'Notificar Acceso al Vigilante',
            msg_acceso_exito: 'Notificación Enviada Correctamente.',
            notificar: 'Notificar',
            acciones: 'Acciones',
            select_video_device: 'Selecciona dispositivo de vídeo',
            msg_captura_foto: 'Haga clic sobre el vídeo para capturar la imagen.',
            comentarios: 'Comentarios',
            salida_exitosa: 'Salida Registrada Correctamente.',
            sin_comentarios: 'Sin Comentarios',
            formato_fecha: 'DD/MM/AAAA',
            recibidos: 'Recibidos',
            enviados: 'Enviados',
            accesos_sin_codigo: 'Accesos sin Código',
            msg_invitation_01: 'Has recibido una invitación del Parque Industrial',
            msg_invitation_02: 'Solo muestra el siguiente código en la caseta de la entrada',
            msg_invitation_company_01: 'Has recibido una invitación de la Empresa',
            codigo: 'Código',
            msg_confirm_assistance: 'Al confirmar se acepta los requerimientos marcados por la empresa anfitriona.',
            msg_files_necessary_attend_invitation: 'Archivos necesarios para atender la invitación: ',
            confirmar_asistencia: 'Confirmar Asistencia',
            confirmed_assistance: 'ASISTENCIA CONFIRMADA',
            ubicacion_maps: 'Ubicación en Google Maps',
            msg_no_permission: 'Usted no tiene permisos para completar esta invitación.',
            msg_access_no_code: 'Captura la foto del rostro del invitado o la del frente de una identificación oficial, así como los demás datos requeridos.',
            msg_must_capture_photo: 'Debe de capturar la foto antes de enviar los datos.',
            msg_no_manager_found: 'No es posible hacer la invitación Empresarial, debido a que no se encontró un Adminsitrador de esa Empresa. Esto puede deberse a que no se ha asignado o se ha eliminado al Adminstrador de esa Empresa.',
            headerInvitationRecivedCompany: 'Reporte de Invitaciones Recibidas a Empresas',
            headerInvitationRecivedCompanyExcel: 'InvitacionesRecibidas(Empresas)',
            headerInvitationRecivedPark: 'Reporte de Invitaciones Recibidas a Parques',
            headerInvitationRecivedParkExcel: 'InvitacionesRecibidas(Parques)',
            headerInvitationSent: 'Reporte de Invitaciones Enviadas',
            headerInvitationSentExcel: 'InvitacionesEnviadas',
            headerAccess: 'Reporte de Accesos',
            headerAccessExcel: 'Accesos con código',
            headerAccessNoCode: 'Reporte de Accesos Sin Código',
            headerAccessNoCodeExcel: 'AccesosSinCódigo',
            period: 'Período: ',
            period2: 'Período',
            page: 'Página ',
            al: ' al ',
            de: ' de ',
            export_to_excel: 'Exportar a Excel',
            export_to_pdf: 'Exportar a PDF',
            download_to_excel: 'Descargar Excel',
            download_to_pdf: 'Descargar PDF',
            reportes: 'Reportes',
            notificaciones: 'Notificaciones',
            canSendEmail: '¿Quieres recibir Correos?',
            canSendSMS: '¿Quieres recibir SMS',
            notificacion_success: 'Configuración Actualizada Correctamente.',
            activar_desactivar: 'Activar/Desactivar',
            activar: 'Activar',
            desactivar: 'Desactivar',
            note_disable_main_resident: 'Nota: Al desactivar la Empresa, se desactivaran a los Empleados, Vigilantes y Administradores de esta Empresa y no podrán Iniciar Sesión.',
            note_enable_main_resident: 'Nota: Al activar la Empresa, se activan los Empleados, Vigilantes y Administradores de esta Empresa.',
            msg_enable_main_resident: '¿Está seguro de Activar la Empresa?',
            msg_disable_main_resident: '¿Está seguro de Desactivar la Empresa?',
            note_disable_invitation_company: 'Nota: Al desactivar Invitaciones de la Empresa, los Empleados y Administradores de la Empresa ya no podrán hacer invitaciones.',
            note_enable_invitation_company: 'Nota: Al activar Invitaciones de la Empresa, los Empleados y Administradores de la Empresa podrán hacer invitaciones.',
            msg_enable_invitation_company: '¿Está seguro de Activar Invitaciones de la Empresa?',
            msg_disable_invitation_company: '¿Está seguro de Desactivar Invitaciones de la Empresa?',
            mensaje_users_activados: 'Usuarios Activados Correctamente.',
            mensaje_users_desactivados: 'Usuarios Desactivados Correctamente.',
            grados: 'Girar',
            fecha_hora_envio: 'Fecha y hora de envío',
            invEmpRecurrentes: 'Invitaciones Empresariales Recurrentes',
            cambiar_empleado_asignado: 'Modificar Empleado Asignado',
            msg_fotos: 'Favor de tomar la foto usando el dispositivo en posición vertical.',
            msg_preregistro: 'Nota: Asegúrate de completar todos los campos correctamente, así como adjuntar todas las fotos que se soliciten.',
            msg_current_employee: 'Actualmente esta invitación esta asignada al Empleado: ',
            msg_current_employee2: 'A continuación seleccione otro.',
            files: 'Archivos',
            file: 'Archivo',
            title_files: 'Archivos que se adjuntan a las invitaciones',
            display_name: 'Nombre para mostrar',
            add_file: 'Añadir Archivo',
            msg_file_added: 'Archivo Añadido Correctamente.',
            msg_file_update: 'Archivo Modificado Correctamente.',
            msg_file_delete: 'Archivo Eliminado Correctamente.',
            msg_eliminar_file: '¿Está seguro de eliminar el Archivo?',
            change_file: 'Cambiar Archivo',
            msg_oversized: 'El tamaño del archivo debe ser menor a 1MB',
            mostrar: "Mostrar",
            tooltip_help: "Reportar un problema",
            search_by_many_fields: 'Buscar por Nombre, Apellido, Celular o E-Mail',
            msg_upgrade_user_provider_from_register_user: 'Solicitud Enviada Corretamente.',
            attemps: 'Intentos Disponibles',
            num_piso: 'Número de Piso',
            access_code: 'Código de Acceso',
            show_floors: 'Mostrar pisos(s)',
            add_floor: 'Agregar piso',
            delete_floor: 'Eliminar Piso',
            change_floor: 'Modificar Piso',
            msg_floor_added: 'Piso Añadido Correctamente.',
            msg_floor_update: 'Piso Modificado Correctamente.',
            msg_floor_delete: 'Piso Eliminado Correctamente.',
            msg_no_floors: 'Actualmente el parque industrial no cuenta con pisos registrados.',
            floors_park: 'Piso(s) del Parque',
            access_code_elevator: 'Código de Acceso Elevador',
            by_SMS: 'por SMS',
            msg_success_sms: 'Mensaje SMS Enviado Correctamente',
            servicio_suspendido: 'Servicio Suspendido',
            msg_supendido: 'Este mensaje se muestra por cualquiera de las 2 siguientes razones:',
            msg_supendido1: 'Debido a que usted no tiene permisos para enviar invitaciones o',
            msg_supendido2: 'Debido a la falta de pago, el servicio de invitaciones ha sido suspendido.',
            msg_supendido3: 'Para más información comuníquese con su Administrador o Proveedor Intrare.',
            msg_invitation_yourself: 'No puede enviarse una invitación a sí mismo.',
            msg_invitation_user_disabled: 'No puedo enviar una invitación a usuarios desactivados.',
            title_elevator_access_days: 'Días de acceso al Elevador.',
            msg1_elevator_access_days: 'Seleccione los días de acceso al elevador.',
            msg2_elevator_access_days: 'Nota: Solamente para edificios corporativos que cuenten con módulos instalados en sus Elevadores.',
            msg_support: 'Para cualquier pregunta, sugerencia y/o aclaración, contáctenos al correo help@intrare.app',
            current_invitations: 'Invitaciones vigentes',
            copy_qr_code: 'Copiar Código QR',
            copy_qr_code_successfully: 'Código QR copiado correctamente.',
            automatic_invitation: 'Invitación automática',
            msg_automatic_subject: 'Invitación generada por el vigilante desde caseta.',
            assigned: 'Asignado',
            assigned_registered: 'Asignado registrado',
            deny_access: 'Denegar acceso ',
            authorized_access: 'Acceso autorizado',
            authorize_access: 'Autoriza el acceso',
            authorize: 'Autorizar acceso',
            send_and_notify_host_access: 'Enviar y Notificar al anfitrión acceso ',
            your_guest: 'Tu invitado',
            the_person: 'La persona',
            has_arrived: 'ha llegado.',
            select_reason: 'Seleccione un motivo: ',
            inappropriate_behavior: 'Comportamiento inadecuado',
            lack_equipment: 'Falta de equipo',
            inconvenient_state_health: 'Estado inconveniente de salud',
            high_temperature: 'Temperatura alta/baja',
            inconsistent_false_data: 'Datos inconsistentes y/o falsos',
            msg_host_notified_correctly: 'El anfitrión fue notificado correctamente',
            deny: 'Denegado',
            msg_invitation_registered_denied: '!ACCESO DENEGADO¡. Acceso denegado por el siguiente motivo: ',
            lider_area: 'Líder de equipo',
            lbl_position: 'Cargo en la Empresa',
            position: 'Cargo',
            comments: 'Comentarios',
            add_comments: 'Agregar Comentarios',
            add_comments_success: 'Comentarios agregados correctamente',
            msg_only_edit_comments: 'Nota: Solo los administradores pueden modificar los comentarios.',
            placas: 'Placas',
            agregar_placas: 'Agregar Placas',
            take_photo: 'Tomar Foto',
            placas_alta: 'Placas Registradas Correctamente.',
            placas_mostrar: 'Ver Placas',
            ban_user: 'Restringir acceso',
            remove_ban: 'Quitar restricción',
            user_banned: 'Usuario Restringido.',
            undefined: 'Indefinido',
            reason: 'Motivo: ',
            reason2: 'Causa: ',
            select_type_ban: 'Selecciona el tipo de Restricción:',
            type_ban: 'Tipo de Restricción',
            banned_people: 'Personas con Restricción',
            show_reasons: 'Mostrar Motivos',
            veto_removed_successfully: 'Restricción eliminado correctamente.',
            msg_veto00: ' Para cualquier duda ponerse en contacto con Administrador interno del Sistema.',
            msg_survey00: 'Para poder acceder a las instalaciones es necesario que el invitado conteste la Encuesta COVID.',
            msg_survey01: 'El Invitado no ha contestado la Encuesta COVID.',
            msg_survey: 'Nota: Se le ha enviado Encuesta automáticamente.',
            header_survey: 'Encuesta COVID 19',
            top1_survey: 'Derivado a la Pandemia COVID-19 se han implementado medidas que nos ayudan a proteger a toda nuestra comunidad, basándose en las recomendaciones actuales de la Organización Mundial de la Salud y los Centros para el Control y Prevención de Enfermedades.',
            top2_survey: 'Para prevenir la propagación de COVID-19 y reducir el riesgo potencial de exposición, se solicita responder una prueba de detección completando este cuestionario al ingreso a las instalaciones.',
            below_survey: 'Cualquier consulta favor de realizarla a tu anfitrión o personal que te brinda atención en el control de acceso de la empresa.',
            msg_below_survey: 'Juntos prevenimos y avanzamos!',
            question1: '1) ¿En los últimos 14 días, ha experimentado algún síntoma de resfriado o de gripe?',
            question2: '2) ¿En los últimos 14 días, ha recibido un diagnóstico confirmado de coronavirus (COVID-19)?',
            question3: '3) ¿En los últimos 14 días, ha tenido contacto o has cuidado a alguien diagnosticado con COVID-19?',
            question4: '4) ¿Ha viajado en los últimos 14 días?',
            temperature: 'Temperatura',
            answer: 'Contestar',
            msg_error_survey: 'Para poder continuar es necesario marcar No a todas las preguntas.',
            instructions: 'Instrucciones',
            instructions_to_display: 'Instrucciones a mostrar',
            share_with: "Compartir con: ",
            shared: "Compartidas",
            multiple_accesses: "Múltiples accesos por día",
            msg_multiple_accesses: "Puede acceder a la Empresa varias veces al día con este código.",
            caseta_in: "Caseta entrada",
            caseta_out: "Caseta salida",
            control_number: "Número de Control",
            type_employee: "Tipo Empleado",
            current: 'Vigente',
            canceled: 'Cancelada',
            employee_number: "Número Empleado",
            msg_user_validated: "Invitado Validado Correctamente.",
            msg_user_invalidated: "Se ha enviado una notificación a su invitado para que corrija sus datos.",
            validar: "Validar",
            msg_guest_corrections: "Nota: Si selecciona Sí, se notificará al invitado para que haga las correcciones necesarias en su registro.",
            msg_no_register_provider_yet1: "Este usuario no ha completado",
            msg_no_register_provider_yet2: "el registro como proveedor.",
            registrar_usuario: 'Registrar usuario',
            registrado: "Registrado",
            no_registrado: "No registrado",
            send_waiting_room: 'Enviar a sala de espera',
            add_carrier_data: 'Agregar datos transporte',
            carrier_data: 'Datos transporte',
            show_carrier_data: 'Mostrar datos transporte',
            case_plates: 'Placas de unidad',
            container_platform_plates: 'Placas del contenedor/plataforma',
            transport_line: 'Línea de transporte',
            supplier_customer_name: 'Nombre del proveedor/cliente',
            load: 'Carga',
            download: 'Descarga',
            at_least_one_data: "Debe de capturar al menos un dato.",
            data_added_successfully: "Datos agregados exitosamente.",
            data_update_successfully: "Datos modificados exitosamente.",
            guardhouse_name_checkin: 'Caseta Entrada',
            guardhouse_name_checkout: 'Caseta Salida',
            enable_tolerance_week_invitations: 'Habilitación de tolerancia',
            msg_enable_tolerance_week_invitations: 'Habilitar tolerancia de una semana a las invitaciones.',
            full_msg_enable_tolerance_week_invitations: 'Permitir que los invitados puedan hacer uso de la ' +
                'invitación individual con una tolerancia de +/- 7 días de la fecha asignada.',
            force_access: 'Forzar acceso',
            msg_out_date_within_tolerance: 'Esta invitación está fuera de fecha. Sin embargo, está dentro de la tolerancia de +/- 7días.',
            // Trajadores
            fecha_inicial: 'Fecha Inicial',
            check_in_time: 'Hora de Entrada',
            check_out_time: 'Hora de Salida',
            worker: 'Contratista',
            workers: 'Contratistas',
            add_worker: 'Añadir Contratista',
            msg_worker_added: 'Contratista Agregado Correctamente.',
            msg_worker_update: 'Contratista Modificado Correctamente.',
            msg_worker_deleted: 'Contratista Eliminado Correctamente.',
            msg_delete_worker: '¿Está seguro de eliminar al Contratista?',
            show_qr_code: 'Mostrar código QR',
            msg_accion_deshacer: 'Esta acción no se puede deshacer.',
            access_days: 'Días de acceso',
            no_records_yet: 'Sin registros todavía.',
            display_info_print: 'Visualizar información para imprimir',
            generate_pdf_printing: 'Generar PDF para imprimir',
            number_cards_sheet: 'Número de tarjetas por hoja',
            msg_record_deleted: 'Registro eliminado correctamente.',
            creacion: 'Creación',
            clients: 'Clientes',
            add_client: 'Añadir Cliente',
            client_name: 'Nombre del Cliente',
            client_number: 'Número del Cliente',
            loading_time: 'Tiempo de carga',
            client_email: 'E-Mail del Cliente',
            client_phone: 'Teléfono del Cliente',
            client_address: 'Dirección del Cliente',
            client_data: 'Datos del Cliente',
            client_data_added: 'Datos del Cliente Agregados Correctamente.',
            client_data_updated: 'Datos del Cliente Actualizados Correctamente.',
            client_data_deleted: 'Datos del Cliente Eliminados Correctamente.',
            msg_delete_client: '¿Está seguro de eliminar al Cliente?',
            msg_delete_client2: 'Esta acción no se puede deshacer.',
            msg_client_deleted: 'Cliente Eliminado Correctamente.',
            no_records_clients: 'No hay registros de Clientes.',
            landing_area: 'Área de carga',
            type_landing_area: 'Tipo Área de Carga',
            add_landing_area: 'Agregar Área de carga',
            msg_landing_area: 'Área de carga agregada correctamente.',
            msg_landing_area_updated: 'Área de carga actualizada correctamente.',
            msg_landing_area_deleted: 'Área de carga eliminada correctamente.',
            msg_delete_landing_area: '¿Está seguro de eliminar el área de carga?',
            no_records_landing_area: 'No hay registros de Áreas de carga.',
            shipments: 'Embarques',
            types_of_transport: 'Tipos de transporte',
            add_type_transport: 'Agregar Tipo de Transporte',
            type_transport: 'Tipo de Transporte',
            msg_type_transport: 'Tipo de Transporte agregado correctamente.',
            msg_type_transport_updated: 'Tipo de Transporte actualizado correctamente.',
            msg_delete_type_transport: '¿Está seguro de eliminar el Tipo de Transporte?',
            msg_type_transport_deleted: 'Tipo de Transporte eliminado correctamente.',
            no_records_type_transports: 'No hay registros de Tipos de Transporte.',
            msg_no_type_transport: 'Actualmente no hay tipos de transporte registrados.',
            descriptionss: 'Descripción',
            attachments_for_the_invitation: 'Archivos adjuntos para la invitación',
            attachment: 'Archivo adjunto',
            add_attachment: 'Agregar archivo adjunto',
            msg_attachment_added: 'Archivo adjunto agregado correctamente.',
            msg_attachment_updated: 'Archivo adjunto actualizado correctamente.',
            msg_attachment_deleted: 'Archivo adjunto eliminado correctamente.',
            msg_delete_attachment: '¿Está seguro de eliminar el archivo adjunto?',
            msg_no_attachments: 'Actualmente no hay archivos adjuntos registrados.',
            msg_attachment_table: 'Documentación que se mostrará en el formulario de invitación',
            msg_documentation_completed: 'Ya ha subido todos los documentos requeridos para la invitación.',
            msg_application_submitted_successfully: 'Solicitud enviada correctamente.',
            access_to_tutors: 'Acceso a tutores',
            parking_lot: 'Estacionamiento',
            check_parking_availability: 'Verificar disponibilidad de estacionamiento',
            parking_section: 'Secciones',
            parking_space: 'Cajones',
            assigned_parking_spaces: 'Cajones Asignados',
            assigned_parking_space: 'Cajon Asignado',
            add_parking_space: 'Agregar cajon',
            msg_parking_space_added: 'Cajon agregado correctamente.',
            msg_parking_space_updated: 'Cajon actualizado correctamente.',
            msg_parking_space_deleted: 'Cajon eliminado correctamente.',
            msg_delete_parking_space: '¿Está seguro de eliminar el cajon?',
            msg_no_parking_space: 'Actualmente no hay cajones registrados.',
            vehicle_type: 'Tipo de vehículo',
            vehicle_types: 'Tipos de vehículos',
            add_vehicle_type: 'Agregar tipo de vehículo',
            msg_vehicle_type_added: 'Tipo de vehículo agregado correctamente.',
            msg_vehicle_type_updated: 'Tipo de vehículo actualizado correctamente.',
            msg_vehicle_type_deleted: 'Tipo de vehículo eliminado correctamente.',
            msg_delete_vehicle_type: '¿Está seguro de eliminar el tipo de vehículo?',
            msg_no_vehicle_type: 'Actualmente no hay tipos de vehículos registrados.',
            form_register_title: 'Formulario de registro',
            register: 'Registrarse',
            validity: 'Vigencia',
            no_spaces_available: 'Actualmente todos los cajones reservados están ocupados.',
            access_history_parking: 'Historial de invitaciones y accesos al Estacionamiento',
            access_parking: 'Acceso al Estacionamiento',
            info_shipment: 'Información del Embarque',
            info_conductor: 'Información del Conductor',
            shipment_details: 'Detalles del Embarque',
            shipments_supervisor: 'Supervisor de Embarques',
            security_supervisor: 'Supervisor de Seguridad',
            shipping_analyst: 'Analista de Embarques',
            supervise_shipments: 'Supervisar Embarques',
            informative_shipments: 'Información de Embarques',
            identification_documents: 'Documentos de Identificación',
            transport_type: 'Tipo de Transporte',
            confirmed: 'Confirmado',
            not_confirmed: 'No Confirmado',
            authorized: 'Autorizado',
            arrival_registered: 'Entrada Registrada',
            registrar_arribo: 'Registrar Entrada',
            mensaje_alta_arribo: 'Entrada Registrada Correctamente.',
            loading_area: 'Área de Carga',
            client_label: 'Cliente',
            access_history_shipments: 'Historial de accesos a los Embarques',
            access_shipments: 'Acceso Embarques',
            manage_companies: 'Alta Empresas',
            has_certification_text: '¿Tiene Texto de Certificación?',
            view_attached_documents: 'Ver Documentos Adjuntos',
            confirmar_seleccion: 'Confirmar Seleccion',
            // Reglas OCR
            active_status: 'Estatus Activo',
            valid_rfc_format: 'Formato RFC Válido',
            valid_curp_format: 'Formato CURP Válido',
            identity_match: 'Coincidencia de Identidad',
            positive_result: 'Opinión Positiva',
            is_current: 'Vigencia',
            verification_result: 'Resultado de Verificación',
            invitar_empresa_externa: 'Invitar Empresa Externa',
            nombre_empresa: 'Nombre de la Empresa',
            nombre_contacto: 'Nombre del Contacto',
            correo_contacto: 'Correo del Contacto',
            empresa_existente: 'Empresa existente',
            empresa_no_registrada: 'Empresa no registrada',
            buscar_empresa: 'Buscar empresa',
            escriba_para_buscar: 'Escriba para buscar...',
            complete_campos_requeridos: 'Por favor complete todos los campos requeridos.',
            maxium_capacity: 'Aforo Máximo en la empresa',
            maxium_capacity_examples: 'Ejemplos: 100, 200, 300',
            rrhh: 'Gestion de Empleados',
            management_permits: 'Gestion de Permisos',
            photographs_and_identification: 'Fotografías e Identificación',
            invitation_rejected: 'Has rechazado la invitación.',
            // Security Module
            security_module: 'Seguridad Patrimonial',
            security_company: 'Empresa de Seguridad',
            security_contract: 'Contrato de Seguridad',
            security_link_provider: 'Vincular Proveedor',
            security_invite_provider: 'Invitar Proveedor',
            security_link_company: 'Vincular Empresa de Seguridad',
            security_invite_admin: 'Invitar Admin de Seguridad',
            security_contract_details: 'Detalles del Contrato',
            security_available_companies: 'Empresas de Seguridad Disponibles',
            security_active_contract: 'Contrato Activo',
            security_no_available_companies: 'No hay empresas de seguridad disponibles en este momento.',
            security_company_linked_success: 'Empresa vinculada correctamente.',
            security_company_unlinked_success: 'Empresa desvinculada correctamente.',
            security_confirm_link: 'Confirmar Vinculación',
            security_confirm_link_text: 'Deseas vincular a',
            security_confirm_unlink: 'Confirmar Desvinculación',
            security_confirm_unlink_text: 'Estás seguro de que deseas desvincular la empresa de seguridad. Esta acción no puede deshacerse.',
            confirm_link_msg: 'Deseas vincular a',
            confirm_unlink_msg: 'Estás seguro de que deseas desvincular la empresa de seguridad. Esta acción no puede deshacerse.',
            security_unlink_company: 'Desvincular Empresa',
            security_link_company_description: 'Selecciona una empresa de seguridad para vincularla a tu organización.',
            security_invite_admin_description: 'Invita a un administrador de una empresa de seguridad para que cree una empresa nueva.',
            security_creation_flow: 'Flujo de Creación',
            security_flow_step1: 'Envía una invitación al correo del futuro administrador',
            security_flow_step2: 'El administrador recibe el correo y accede al enlace de invitación',
            security_flow_step3: 'El administrador completa sus datos y crea su empresa de seguridad',
            security_change_provider: 'Cambiar Proveedor',
            security_send_invitation: 'Enviar Invitación',
            security_invitation_sent_success: 'Invitación enviada exitosamente.',
            security_contract_info: 'Información del Contrato',
            security_contract_description: 'Este es tu contrato activo con la empresa de seguridad. Desde aquí puedes gestionar tu relación de seguridad.',
            security_next_steps: 'Próximos Pasos',
            security_next_step_1: 'El proveedor creará y asignará guardias a tu organización',
            security_next_step_2: 'De acuerdo con tu empresa, los guardias realizarán sus turnos',
            security_next_step_3: 'Puedes reemplazar el proveedor en cualquier momento',
            security_no_active_contract: 'No tienes un contrato activo de seguridad. Vincula una empresa o invita a un nuevo proveedor.',
            security_info: 'Información',
            security_invite_new_provider: 'Invitar Nuevo Proveedor',
            error_linking_company: 'Error al vincular la empresa.',
            error_unlinking_company: 'Error al desvincular la empresa.',
            company_name: 'Nombre de Empresa',
            contact_email: 'Email de Contacto',
            website: 'Sitio Web',
            email: 'Correo Electrónico',
            first_name: 'Nombre',
            last_name: 'Apellido',
            telephone: 'Teléfono',
            status: 'Estado',
            active: 'Activo',
            inactive: 'Inactivo',
            select: 'Seleccionar',
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            unlink: 'Desvincular',
            loading: 'Cargando',
            step: 'Paso',
            email_required: 'El correo electrónico es requerido.',
            email_invalid: 'Por favor ingresa un correo electrónico válido.',
            first_name_required: 'El nombre es requerido.',
            last_name_required: 'El apellido es requerido.',
            security_invitation_pending_message: 'Ya tienes una invitación activa enviada. El administrador debe completar el proceso de registro antes de enviar una nueva invitación.',
            error_sending_invitation: 'Error al enviar la invitación.',
            security_create_company: 'Crear Empresa de Seguridad',
            security_invitation_data: 'Datos de tu Invitación',
            security_credentials: 'Credenciales de Acceso',
            security_company_info: 'Información de la Empresa',
            security_location: 'Ubicación de la Empresa',
            security_documents: 'Documentos',
            password: 'Contraseña',
            password_required: 'La contraseña es requerida.',
            password_min_length: 'La contraseña debe tener mínimo 8 caracteres.',
            name_required: 'El nombre es requerido.',
            address: 'Dirección',
            address_required: 'La dirección es requerida.',
            telephone_required: 'El teléfono es requerido.',
            company_name: 'Nombre de la Empresa',
            company_logo: 'Logo de la Empresa',
            web_page: 'Página Web',
            scian: 'Código SCIAN',
            classification: 'Clasificación',
            latitude: 'Latitud',
            longitude: 'Longitud',
            map_url: 'URL del Mapa',
            validity_date: 'Fecha de Validez',
            file_selected: 'Archivo seleccionado',
            file_too_large: 'El archivo es demasiado grande (máximo 5MB).',
            invalid_token: 'Token de invitación inválido o expirado.',
            error_fetching_invitation: 'Error al recuperar los datos de la invitación.',
            error_creating_company: 'Error al crear la empresa.',
            security_company_created_success: 'Empresa creada exitosamente. Redirigiendo al login...',
            back: 'Atrás',
            select_file: 'Seleccionar Archivo',
            created_at: 'Fecha de Creación',
            pending_invitation: 'Invitación Pendiente',
            security_contract_info: 'Información del Contrato',
            security_next_steps: 'Próximos Pasos',
            security_next_step_1: 'El proveedor creará y asignará guardias a tu organización',
            security_next_step_2: 'De acuerdo con tu empresa, los guardias realizarán sus turnos',
            security_next_step_3: 'Puedes reemplazar el proveedor en cualquier momento',
            security_change_provider_description: 'Selecciona una nueva empresa de seguridad para reemplazar al proveedor actual.',
            security_no_other_providers: 'No hay otras empresas de seguridad disponibles para cambiar.',
            Empresa: 'Empresa',
            security_admin_dashboard: 'Panel de Administración de Seguridad',
            security_admin_dashboard_welcome: 'Gestiona tu empresa de seguridad, guardias y turnos desde aquí.',
            security_total_guards: 'Total de Guardias',
            security_guards_on_shift: 'Guardias en Turno',
            security_total_clients: 'Clientes Asignados',
            security_total_shifts: 'Turnos Activos',
            security_company_info_title: 'Información de tu Empresa',
            security_company_name: 'Nombre de Empresa',
            security_company_id: 'ID de Empresa',
            security_total_active_guards: 'Total de Guardias Activos',
            security_assigned_clients: 'Clientes Asignados',
            security_no_clients_assigned: 'No hay clientes asignados aún.',
            security_manage_guards: 'Gestionar Guardias',
            security_no_guards_created: 'Aún no has creado guardias.',
            security_active_shifts: 'Turnos Activos en Tiempo Real',
            security_no_active_shifts: 'No hay turnos activos en este momento.',
            security_create_new_guard: 'Crear Nuevo Guardia',
            security_assign_guard: 'Asignar Guardia a Cliente',
            security_select_client: 'Selecciona un cliente',
            security_select_client_required: 'Debes seleccionar un cliente.',
            security_guard_details: 'Detalles del Guardia',
            security_assigned_to: 'Asignado a',
            security_guard_created_success: 'Guardia creado exitosamente.',
            security_guard_assigned_success: 'Guardia asignado exitosamente.',
            security_guard_deleted_success: 'Guardia eliminado exitosamente.',
            security_pending_contracts: 'Contratos Pendientes',
            security_pending: 'Solicitud Pendiente',
            // Park Linking Flow
            security_pending_park_contracts: 'Contratos de Vinculación de Parques',
            security_pending_park_contracts_description: 'Solicitudes de vinculación de empresas de seguridad para tus parques',
            security_requests_pending: 'Solicitudes Pendientes',
            security_review_and_respond: 'Revisa y responde la solicitud de vinculación',
            security_reject: 'Rechazar',
            security_approve: 'Aprobar',
            security_no_pending_contracts: 'No hay solicitudes pendientes de vinculación',
            security_no_contracts_message: 'No hay solicitudes de vinculación pendientes en este momento',
            security_no_contracts_description: 'Todos los contratos están resueltos',
            security_confirm_approve: 'Confirmar Aprobación',
            security_confirm_reject: 'Confirmar Rechazo',
            security_contract_approved: 'Contrato aprobado correctamente',
            security_contract_rejected: 'Contrato rechazado correctamente',
            error_responding_to_contract: 'Error al responder al contrato',
            error_fetching_contracts: 'Error al obtener los contratos pendientes',
            error_park_not_found: 'Parque no encontrado',
            error_permission_denied: 'No tienes permiso para acceder a este parque',
            security_linking_request_label: 'Solicitud de vinculación',
            park_name: 'Nombre del Parque',
            requested_at: 'Solicitado el',
            security_my_parks: 'Mis Parques Vinculados',
            security_my_parks_description: 'Parques donde tu empresa de seguridad está vinculada',
            security_total_parks: 'Total de Parques',
            security_assign_guards_to_park: 'Asignar Guardias al Parque',
            security_guard_assigned_to_park: 'Guardia asignado al parque correctamente',
            security_unlink_park: 'Desvincular Parque',
            security_unlink_park_success: 'Parque desvinculado correctamente',
            security_unlink_park_confirmation: '¿Estás seguro de que deseas desvincular este parque? Los guardias asignados serán desasignados y los turnos activos se cerrarán.',
            status_pending: 'Pendiente',
            status_active: 'Activo',
            status_rejected: 'Rechazado',
            security_link_new_park: 'Vincular Nuevo Parque',
            security_pending_approval: 'Esta vinculación está pendiente de aprobación por el administrador del parque',
            security_assign_guards: 'Asignar Guardias',
            security_unlink: 'Desvincular',
            security_no_parks_linked: 'No hay parques vinculados',
            security_link_park_now: 'Vincular Parque Ahora',
            security_confirm_unlink_park: 'Confirmar Desvinculación',
            confirm_unlink_park_msg: '¿Estás seguro de que deseas desvincular',
            security_unlink_warning: 'Advertencia: Los guardias asignados a este parque serán desasignados y los turnos activos se cerrarán.',
            security_park_unlinked_success: 'Parque desvinculado correctamente',
            security_available_parks: 'Parques Disponibles para Vincular',
            security_available_parks_description: 'Parques donde puedes enviar una solicitud de vinculación',
            security_send_linking_request: 'Enviar Solicitud',
            security_linking_request_sent: 'Solicitud de vinculación enviada correctamente. Esperando aprobación del administrador del parque.',
            security_no_active_contracts: 'No hay contratos activos en este momento',
            security_no_active_guards: 'No hay guardias activos en caseta',
            security_company: 'Empresa de Seguridad',
            security_module: 'Módulo de Seguridad',
            security_new_contract: 'Sin Contrato',
            security_contract_pending: 'Solicitud Pendiente',
            security_contract_active: 'Vinculado',
            security_contract_rejected: 'Rechazado',
            security_patrimonial_menu: 'Seguridad Patrimonial',
            security_geofences: 'Geocercas',
            security_geofences_description: 'Dibuja el perímetro de tu empresa o parque para delimitar el área de seguridad',
            security_geofences_new: 'Nueva Geocerca',
            security_geofences_drawing_hint: 'Hacé clic en el mapa para agregar puntos al perímetro',
            security_geofences_points_count: 'Puntos: {count}',
            security_geofences_undo_point: 'Deshacer último punto',
            security_geofences_cancel_drawing: 'Cancelar',
            security_geofences_finish_drawing: 'Finalizar y Guardar',
            security_geofences_min_points: 'Necesitás al menos 3 puntos para formar un polígono',
            security_geofences_name: 'Nombre de la geocerca',
            security_geofences_name_required: 'El nombre es requerido',
            security_geofences_description_field: 'Descripción (opcional)',
            security_geofences_save: 'Guardar Geocerca',
            security_geofences_created_success: 'Geocerca creada exitosamente',
            security_geofences_error_creating: 'Error al crear la geocerca',
            security_geofences_error_fetching: 'Error al obtener las geocercas',
            security_geofences_empty: 'Todavía no cargaste ninguna geocerca',
            security_geofences_delete_confirm_title: 'Eliminar Geocerca',
            security_geofences_delete_confirm_msg: '¿Estás seguro de que deseas eliminar la geocerca',
            security_geofences_deleted_success: 'Geocerca eliminada correctamente',
            security_geofences_error_deleting: 'Error al eliminar la geocerca',
            security_geofences_toggle_active_success: 'Estado de la geocerca actualizado',
            security_geofences_error_updating: 'Error al actualizar la geocerca',
            security_geofences_active: 'Activa',
            security_geofences_inactive: 'Inactiva',
            security_geofences_locate_me: 'Ubicarme en el mapa',
            security_rounds: 'Rondines',
            security_rounds_start: 'Iniciar Rondín',
            security_rounds_select_geocerca: 'Selecciona el perímetro a rondar',
            security_rounds_no_geocercas: 'No hay geocercas disponibles para rondar. Contactá a tu administrador.',
            security_rounds_checkpoints_visited: 'checkpoints visitados',
            security_rounds_checkpoints: 'Checkpoints',
            security_rounds_visited_at: 'Visitado a las',
            security_rounds_outside_geofence: 'Fuera del perímetro',
            security_rounds_capture_photo: 'Tomar Foto',
            security_rounds_retake_photo: 'Repetir Foto',
            security_rounds_camera_error: 'No se pudo acceder a la cámara. Revisá los permisos del navegador.',
            security_rounds_gps_error: 'No se pudo obtener tu ubicación GPS. Activá el permiso de ubicación.',
            security_rounds_visit_notes: 'Notas (opcional)',
            security_rounds_send_visit: 'Registrar Visita',
            security_rounds_visit_registered: 'Visita registrada correctamente',
            security_rounds_error_registering: 'Error al registrar la visita al checkpoint',
            security_rounds_error_starting: 'Error al iniciar el rondín',
            security_rounds_complete: 'Completar Rondín',
            security_rounds_incomplete_warning: 'Todavía hay checkpoints sin visitar. ¿Deseás completar el rondín de todas formas?',
            security_rounds_final_notes: 'Notas finales',
            security_rounds_completed_success: 'Rondín completado exitosamente',
            security_rounds_error_completing: 'Error al completar el rondín',
            security_rounds_history: 'Historial de Rondines',
            security_rounds_no_history: 'Todavía no tenés rondines registrados',
            security_rounds_no_visits: 'Sin checkpoints visitados en este rondín',
            security_rounds_in_progress: 'En progreso',
            security_checkpoints_title: 'Checkpoints',
            security_checkpoints_add: 'Agregar Checkpoint',
            security_checkpoints_hint: 'Hacé clic en el mapa, dentro del perímetro, para ubicar el checkpoint',
            security_checkpoints_name: 'Nombre del checkpoint',
            security_checkpoints_name_required: 'El nombre es requerido',
            security_checkpoints_radius: 'Radio de cobertura (metros)',
            security_checkpoints_radius_hint: 'Mínimo 10 metros',
            security_checkpoints_radius_error: 'El radio debe ser de al menos 10 metros',
            security_checkpoints_order: 'Orden en el recorrido',
            security_checkpoints_save: 'Guardar Checkpoint',
            security_checkpoints_radius_label: 'Radio',
            security_checkpoints_created_success: 'Checkpoint creado exitosamente',
            security_checkpoints_error_creating: 'Error al crear el checkpoint',
            security_checkpoints_empty: 'Esta geocerca todavía no tiene checkpoints',
            direccion: 'Dirección',
            error_creating_guard: 'Error al crear el guardia.',
            error_assigning_guard: 'Error al asignar el guardia.',
            error_deleting_guard: 'Error al eliminar el guardia.',
            error_unassigning_guard: 'Error al desasignar el guardia.',
            security_available_guards: 'Guardias Disponibles',
            assigned_park: 'Parque Asignado',
            assigned_company: 'Empresa Asignada',
            available: 'Disponible',
            active: 'Activo',
            inactive: 'Inactivo',
            security_assign: 'Asignar',
            security_unassign: 'Desasignar',
            security_no_guards_available: 'No hay guardias disponibles',
            security_guard_unassigned_success: 'Guardia desasignado correctamente',
            security_select_park_description: 'Selecciona el parque al que deseas vincular tu empresa',
            security_select_park: 'Selecciona un Parque',
            security_send_request: 'Enviar Solicitud',
            security_select_park_first: 'Selecciona un parque primero',
            security_link_company: 'Vincular Empresa de Seguridad',
            security_link_company_description: 'Administra la vinculación de tu empresa de seguridad con los parques',
            security_active_contract: 'Contrato Activo',
            contact_email: 'Email de Contacto',
            security_unlink_company: 'Desvincular Empresa',
            security_available_companies: 'Empresas Disponibles',
            select: 'Seleccionar',
            security_no_available_companies: 'No hay empresas disponibles',
            security_confirm_link: 'Confirmar Vinculación',
            confirm_link_msg: '¿Confirmas que deseas vincular tu empresa a este parque?',
            confirm: 'Confirmar',
            security_confirm_unlink: 'Confirmar Desvinculación',
            confirm_unlink_msg: '¿Estás seguro de que deseas desvincular tu empresa de este parque?',
            unlink: 'Desvincular',
            security_company_linked_success: 'Empresa vinculada correctamente',
            confirm_delete_guard: '¿Estás seguro de que quieres eliminar este guardia?',
            security_invitation_pending_message: 'Ya tienes una invitación activa enviada. El administrador debe completar el proceso de registro antes de enviar una nueva invitación.',
            error_sending_invitation: 'Error al enviar la invitación.',
            security_create_company: 'Crear Empresa de Seguridad',
            security_invitation_data: 'Datos de tu Invitación',
            security_credentials: 'Credenciales de Acceso',
            security_company_info: 'Información de la Empresa',
            security_location: 'Ubicación de la Empresa',
            security_documents: 'Documentos',
            password: 'Contraseña',
            password_required: 'La contraseña es requerida.',
            password_min_length: 'La contraseña debe tener mínimo 8 caracteres.',
            name_required: 'El nombre es requerido.',
            address: 'Dirección',
            address_required: 'La dirección es requerida.',
            telephone_required: 'El teléfono es requerido.',
            company_logo: 'Logo de la Empresa',
            web_page: 'Página Web',
            scian: 'Código SCIAN',
            classification: 'Clasificación',
            latitude: 'Latitud',
            longitude: 'Longitud',
            map_url: 'URL del Mapa',
            validity_date: 'Fecha de Validez',
            file_selected: 'Archivo seleccionado',
            file_too_large: 'El archivo es demasiado grande (máximo 5MB).',
            invalid_token: 'Token de invitación inválido o expirado.',
            error_fetching_invitation: 'Error al recuperar los datos de la invitación.',
            error_creating_company: 'Error al crear la empresa.',
            security_company_created_success: 'Empresa creada exitosamente. Redirigiendo al login...',
            back: 'Atrás',
            select_file: 'Seleccionar Archivo',
            badge_number: 'Número de Placa',
            username: 'Usuario',
            create: 'Crear',
            assign: 'Asignar',
            view: 'Ver',
            delete: 'Eliminar',
            close: 'Cerrar',
            in_progress: 'En Progreso',
            name: 'Nombre',
            security_admin_panel: 'Panel de Guardias',
            security_manage_guards: 'Gestionar Guardias',
            security_guards_list: 'Lista de Guardias',
            security_manage_guards_description: 'Crea y gestiona los guardias de tu empresa de seguridad.',
            security_shifts_list: 'Lista de Turnos',
            security_active_shifts_description: 'Monitorea los turnos activos de tus guardias en tiempo real.',
            security_guards_on_duty: 'Guardias de Servicio',
            security_locations_covered: 'Ubicaciones Cubierto',
            quick_actions: 'Acciones Rápidas',
            security_company: 'Empresa de Seguridad',
            security_total_active_shifts: 'Total de Turnos Activos',
            crear_empleado: 'Crear empleado',
            general_information: 'Información general',
            documentation: 'Documentación',
            //Detalles del Vehículo
            detalles_vehiculo: 'Detalles del Vehículo',
            placa_vehiculo: 'Placa del Vehículo',
            marca: 'Marca',
            modelo: 'Modelo',
            color: 'Color',
            propietario: 'Propietario',
            telefono: 'Teléfono',
            pesajes: 'Pesajes',
            peso_entrada: 'Peso de Entrada',
            peso_salida: 'Peso de Salida',
            peso_neto: 'Peso Neto',
            tons_to_ship: 'Toneladas a embarcar',
            branch_transfer_tons: 'Toneladas traslado sucursal',
            registrar_pesaje: 'Registrar Pesaje',
            mensaje_alta_pesaje: 'Pesaje registrado correctamente.',
            historial_pesajes: 'Historial de Pesajes',
            no_historial_pesajes: 'No hay registros de pesajes para este vehículo.',
            // Exportación de accesos a parqueadero
            tipo_acceso_transportista: 'Tipo Acceso',
            transportista_nombre: 'Transportista Nombre',
            transportista_apellido: 'Transportista Apellido',
            telefono_transportista: 'Teléfono',
            vehiculo: 'Vehículo',
            exportar_pdf: 'Exportar PDF',
            exportar_excel: 'Exportar Excel',
            // Estados de Unidades Activas
            ARRIVED: 'Llegada',
            IN_PLANT: 'En Planta',
            LOADING: 'Cargando',
            UNLOADING: 'Descargando',
            COMPLETED: 'Completado',
            DEPARTED: 'Salida',
            NOT_STARTED: 'No Iniciado',
            IN_PROGRESS: 'En Progreso',
            // Estados de Carga
            'NOT STARTED': 'No Iniciado',
            'IN PROGRESS': 'En Progreso',
            // Estados de Ventanas de Embarques
            PROGRAMADA: 'Programada',
            CONFIRMADA: 'Confirmada',
            EN_SITIO: 'En Sitio',
            EN_PROCESO: 'En Proceso',
            LIBERADA: 'Liberada',
            COMPLETADA: 'Completada',
            CANCELADA: 'Cancelada',
            // Tipos de Movimiento
            EMBARQUE: 'Embarque',
            RECEPCION: 'Recepción',
            operation_type: 'Tipo de Operación',
            // Authorize Access
            autorizar_acceso: 'Autorizar Acceso',
            acceso_no_encontrado: 'Acceso no encontrado',
            no_autorizado: 'No autorizado',
            error_cargar_acceso: 'Error al cargar el acceso',
            confirmar_autorizar_acceso: '¿Está seguro de que desea autorizar este acceso?',
            acceso_autorizado: 'Acceso autorizado correctamente',
            error_autorizar_acceso: 'Error al autorizar el acceso',
            confirmar_rechazar_acceso: '¿Está seguro de que desea rechazar este acceso?',
            error_rechazar_acceso: 'Error al rechazar el acceso',
            volver: 'Volver',
            del: 'del',
            error: 'Error',
            cargando: 'Cargando',
            reintentar: 'Reintentar',
            no_acciones_disponibles: 'No hay acciones disponibles para este acceso',
            no_tiene_permisos: 'No tiene permisos para realizar esta acción',
            confirmada: 'Confirmada',
            veces_utilizada: 'Veces utilizada',
            rechazar: 'Rechazar',
            invitado: 'Invitado',
            informacion_invitacion: 'Información de la Invitación',
        },
        en: {
            //Login
            intrare_empresa: 'Intrare Company',
            mensaje_login: 'Access to the system',
            ingresar: 'Login',
            mensaje_olvidar_contrasena: 'Did you forget your password?',
            mensaje_link_restablecer1: 'Click ',
            mensaje_link_restablecer2: 'here',
            mensaje_link_restablecer3: 'to reset it.',
            msg_password_reset: 'Enter your E-Mail and then we will send you a temporary password.',
            msg_password_reset_done1: 'We have sent you a temporary password by E-Mail.',
            msg_password_reset_done2: 'You should receive the email shortly!',
            Bienvenido: 'Welcome',
            agregar: 'Add',
            asociar: 'Associate',
            modificar: 'Change',
            modificar_hora: 'Change Time',
            cerrar: 'Close',
            Buscar: 'Search',
            ningun_resultado_1: 'The search for',
            ningun_resultado_2: 'found no results.',
            prep_de: 'of',
            filas_por_pagina: 'Rows per page',
            todos: 'All',
            region: 'en-US',
            Ayuda: 'Help',
            Administrador: 'Manager',
            AdministradorParque: 'Industrial Park Manager',
            Vigilante_entrada: 'Guard/Check-in',
            Vigilante_salida: 'Guard/Check-out',
            Vigilante: 'Guard',
            Vigilante_Parque: 'Industrial Park Guard',
            SuperAdministrador: 'SuperManager',
            //Menú Empleado
            Historial_Invitaciones_Enviadas: 'History of invitations Sent',
            Historial_Invitaciones_Recibidas: 'History of invitations received',
            Historial_Accesos: 'Access history with code',
            Historial: 'Record',
            Historial_Empleados: 'Employee Record',
            //Menú Vigilante
            bitacora: 'Log',
            type_of_access: 'Type of access',
            entradas_salidas: 'Check-In/Check-Out',
            acceso_sin_codigo: 'Check-In No Code',
            acceso_con_codigo: 'Check-In Code',
            entrada_salida_no_code: 'Check-In No Code',
            historial_accesos_sin_codigo: 'Access history no code',
            access_log: 'Access log',
            //Menú Administrador
            Invitaciones: 'Invitations',
            Accesos: 'Access',
            firma_salida: 'Sign exit pass',
            firmado: 'Signed',
            no_firmado: 'Unsigned',
            firmar: 'Sign it',
            mensaje_pase_salida_firmado: 'Exit pass signed successfully.',
            no_registros_pase_salida: 'There are no access records.',
            mensaje_pase_salida: 'People within the Company',
            Casetas: 'Guard Houses',
            Vigilantes: 'Guards',
            boton_emergencia: 'Emergency Button',
            emergencia: 'Emergency',
            evacuacion: 'Evacuation',
            //Empleados
            Empleados: 'Employees',
            AnadirEmpleado: 'Add Employee',
            mensaje_empleado_alta: 'Employee Added Successfully.',
            mensaje_empleado_modificado: 'Employee Modified Correctly.',
            Area: 'Area',
            Nombre: 'First Name',
            Apellido: 'Last Name',
            Invitacion: 'Invitation',
            puede_enviar: 'You can send invitations',
            puede_enviar2: 'It can send invitations',
            extension: 'Extension',
            ine_frente: 'Image front identification',
            foto_ine: 'Official Photo Identification (Driver License, Passport)',
            ine_atras: 'Image back Identification',
            celular: 'Cell phone',
            celular_invitado: 'Guest\'s cell phone',
            password: 'Password',
            current_password: 'Current Password',
            new_password: 'New Password',
            password_confirm: 'Confirm New Password',
            password_confirm2: 'Confirm Password',
            change_password: 'Change Password',
            Activo: 'Active',
            //Casetas
            AnadirCaseta: 'Add Guard House',
            mensaje_caseta_alta: 'Guard House Added Successfully.',
            mensaje_caseta_modificada: 'Guard House Modified Successfully.',
            mensaje_caseta_eliminada: 'Guard House Removed Successfully.',
            //Vigilantes
            anadir_vigilante: 'Add Guard',
            mensaje_vigilante_alta: 'Guard Added Successfully.',
            mensaje_vigilante_modificado: 'Guard Modified Successfully.',
            mostrar_info_invit: 'Show invitation information',
            info_invitation: 'INVITATION INFORMATION',
            info_invitado: 'GUEST INFORMATION',
            info_contractor: 'CONTRACTOR INFORMATION',
            info_anfitrion: 'HOST INFORMATION',
            datos_coche: 'Car data',
            guardar: 'Save',
            acceso: 'Access',
            registrar_entrada: 'Check In',
            registrar_salida: 'Check Out',
            form_salida: 'Exit Form',
            mensaje_alta_acceso_in: 'Access Registered Successfully.',
            mensaje_alta_acceso_out: 'Registered Exit Successfully.',
            canceled_invitation: 'CANCELED INVITATION!',
            msg_canceled_invitation_offline: 'This invitation has been canceled by the Host.',
            msg_canceled_invitation: 'ACCESS DENIED! This invitation has been canceled by the Host.',
            mensaje_qr_no_valido: 'ACCESS DENIED!. QR code, Invalid.',
            mensaje_qr_no_parque_empresa: 'ACCESS DENIED!. The invitation does not match to the Industrial Park or Company.',
            mensaje_qr_no_vigente: 'ACCESS DENIED!. The invitation is not yet valid.',
            mensaje_qr_expirado: 'ACCESS DENIED!. The invitation has expired.',
            mensaje_qr_no_confirmado: 'ACCESS DENIED!. Guest has not confirmed the invitation.',
            mensaje_qr_no_empresa: 'ACCESS DENIED!. The invitation does not match to the Company.',
            mensaje_qr_vetado: 'ACCESS DENIED!. ',
            mensaje_acceso_completo: 'Access has already been completed with the corresponding invitation.',
            mensaje_alta_acceso_without: 'Access Registered Successfully.',
            mensaje_alta_usuario: 'User registered successfully.',
            //Invitación
            Empleado: 'Employee',
            fecha_hora: 'Date and Hour for Invitation',
            fecha_inv: 'Date for Invitation',
            fecha_expiracion: 'Expiration date',
            fecha_envio: 'Shipping date',
            hora_inv: 'Hour for Invitation',
            Asunto: 'Subject',
            placeholder_asunto: 'Write the Subject of the Invitation',
            mensaje_equipo: 'Required safety equipment:',
            equipo_seguridad: 'Equipment',
            mensaje_vehiculo: 'Access with vehicle?',
            enviar_codigo: 'Send Code',
            Notas: 'Notes',
            placeholder_notas: 'Write Extra Notes for the Invitation',
            Si: 'Yes',
            invitación_referido: 'Referred Invitation',
            ininvitación_normal: 'Invitation',
            mensaje_invitacion_alta: 'Invitation Sent Successfully.',
            //Empresas
            Empresas: 'Companies',
            AnadirEmpresa: 'Add Company',
            AsociarEmpresa: 'Associate Company',
            telefono: 'Telephone',
            logotipo: 'Logotype',
            pagina_web: 'Web page',
            clasificacion: 'Classification',
            latitud: 'Latitude',
            longitud: 'Longitude',
            url_mapa: 'URL map',
            vigencia: 'Expiration Date',
            Parque: 'Park',
            mensaje_empresa_alta: 'Company Added Successfully.',
            mensaje_empresa_modificado: 'Company Modified Successfully.',
            mensaje_empresa_asociada_alta: 'Company Associate Successfully',
            mensaje_empresa_asociada_eliminada: 'Associate Company  Deleted Successfully',
            //Parques
            Parques: 'Parks',
            Parques_Industriales: 'Industrial Parks',
            AnadirParque: 'Add Park',
            nombre: 'Name',
            direccion: 'Address',
            mensaje_parque_alta: 'Park Added Successfully.',
            mensaje_parque_modificado: 'Park Modified Successfully.',
            //Administradores
            Administradores: 'Managers',
            anadir_administrador: 'Add Manager',
            Empresa: 'Company',
            company_name: 'Company name',
            data_company: 'Company Manager Data',
            mensaje_administrador_alta: 'Manager Added Successfully',
            mensaje_administrador_modificado: 'Manager Modified Successfully.',
            mensaje_administrador_eliminado: 'Manager Deleted Successfully.',
            //Áreas
            Areas: 'Areas',
            anadir_area: 'Add Area',
            mensaje_areas_alta: 'Area Added Successfully.',
            mensaje_areas_modificado: 'Area Modified Successfully.',
            //Contactos
            contactos: 'Contacts',
            anadir_contacto: 'Add Contact',
            mensaje_contacto_alta: 'Contact Added Successfully.',
            mensaje_contacto_modificado: 'Contact Modified Correctly.',
            //Grupos
            grupos: 'Groups',
            anadir_grupo: 'Add Group',
            mensaje_grupo_alta: 'Group Added Successfully.',
            mensaje_grupo_modificado: 'Group Modified Successfully.',
            mensaje_grupo_delete: 'Group Removed Successfully.',
            eliminar: 'Delete',
            //ContactosXGrupo
            contactosXgrupo: 'Contacts By Group',
            mensaje_contactoXgrupo_alta: 'Contact Added Correctly to the Group.',
            mensaje_contactoXgrupo_delete: 'Contact Deleted from the Group Correctly.',
            //Invitaciones
            Filtrar: 'Filter',
            select_fecha: 'Select date:',
            mostrando_inv_dia: 'Showing invitations of the day:',
            mostrando_historial_dia: 'Showing History filtered by:',
            msg_people_inside_company: 'People within the company to date:',
            Fecha: 'Date',
            Fecha_ini: 'Initial date',
            Fecha_fin: 'Final date',
            Visitante: 'Guest',
            Visitantes: 'Guest(s)',
            Anfitrion: 'Host',
            hora_llegada: 'Arrival time',
            hora_acceso: 'Entry time ',
            hora_salida: 'Departure time',
            Tipo: 'Type',
            no_registros_invit: 'There are no invitation records for that day.',
            no_records_waiting_room: 'There is no one in the waiting room yet.',
            no_registros_proveedores: 'There are no Suppliers records.',
            //Accesos
            section_name: 'Section',
            add_section: 'Add Section',
            msg_section_added: 'Section added successfully.',
            msg_section_updated: 'Section updated successfully.',
            msg_section_deleted: 'Section deleted successfully.',
            msg_delete_section: 'Are you sure to delete the section?',
            section: 'Section',
            creacion: 'Creation',
            espacios: 'Spaces',
            no_registros_accesos: 'There are no access records for that day.',
            //Accesos/Salidas
            mensaje_acercar_QR: 'Bring the QR code closer to the camera.',
            Leer: 'Read',
            enviar: 'Send',
            selecciona_caseta: 'Choose a Guard House',
            aceptar: 'Accept',
            no_resultados: 'No results',
            page_not_found: 'Page not found. !!!',
            page_not_found1: 'The requested URL',
            page_not_found2: 'was not found on this server.',
            inicio: 'Home',
            atras: 'Back',
            preregistro: 'Pre-registration',
            registro_exito: 'Data Sent Successfully',
            msj_cerrar_pagina: 'Your data is in the process of validation.',
            msj2_cerrar_pagina: 'Once validated you will be notified by SMS and / or E-Mail.',
            msj_cerrar_pagina_complemento: 'You can close this page.',
            identidad_exito: 'Identity Confirmed Correctly',
            identidad_exito2: 'Thank you for Confirming Identity',
            identidad_desconocido: 'Guest unrecognized.',
            identidad_desconocido2: 'The guest will be notified shortly to correct the data.',
            pgt_seguro: 'Are you sure you don\'t know the guest?',
            foto_perfil: 'Profile Picture',
            confirmar_identidad: 'Confirm Identity',
            msg_know_guest: 'Do you recognize the Guest?',
            msg_notificacion_anfitrion: 'A Notification has been sent to the Host.',
            estado: 'Status',
            adentro: 'Inside',
            completado: 'Completed',
            waiting_room: 'Waiting room',
            pending_authorization: 'Pending authorization',
            subir_imagen: 'Upload Image',
            update_image: 'Update Image',
            qr_code: 'QR Code',
            msg_qr_code: 'Enter QR Code',
            invitados: 'Guest(s)',
            invitados_no_confirmados: 'Pending Record(s)',
            placeholder_invitados: 'Search by E-Mail',
            placeholder_invitados2: 'Search by name/email/cell phone',
            placeholder_empresas: 'Search by Company',
            add_new_contact: 'Add New Contact',
            add_new_employee: 'Add New Employee',
            invitacion_grupal: 'Group Invitation',
            pagina_caduca: 'This page has expired.',
            survey_success: 'Survey sent successfully.',
            sin_permisos: 'You do not have permission to do this.',
            aviso: 'Notice',
            cancelar: 'Cancel',
            detalle: 'Detail',
            detalle_invit: 'Invitation Details',
            detalle_invit_recibidas: 'Detail of the Invitation Received',
            detalle_access: 'Access Details',
            pendiente: 'Pending',
            info_acceso: 'ACCESS INFORMATION',
            fecha_hora_acceso_in: 'Date and Time of Access',
            fecha_hora_acceso: 'Date and Time Access',
            fecha_hora_acceso_out: 'Date and time of departure',
            pase_salida: 'Pass out',
            confirmar: 'Confirm',
            email_admin: 'Email Manager',
            lbl_invit_empresarial: 'Business Invitation',
            lbl_VIP_invitation: 'VIP invitation',
            tooltip_vip_invitation: 'The VIP invitation enables us to enter the guest daily without validity.',
            lbl_host_company: 'Host Company',
            add_equipo_seguridad: 'Add security equipment',
            mensaje_areas_equipo_alta: 'Security Equipment Removed Successfully.',
            mensaje_areas_equipo_update: 'Security Equipment Modified Successfully.',
            mensaje_areas_equipo_delete: 'Security Equipment Removed Successfully.',
            lbl_invitacion_recurrente: 'Recurrent Invitation',
            Lunes: 'Monday',
            Martes: 'Tuesday',
            Miercoles: 'Wednesday',
            Jueves: 'Thursday',
            Viernes: 'Friday',
            Sabado: 'Saturday',
            Domingo: 'Sunday',
            lbl_selecciona_dias: 'Select days',
            normal: 'Normal',
            empresarial: 'Enterprise',
            recurrente: 'Recurrent',
            msg_eliminar_company_associate: 'Are you sure to unlink this Company from your Industrial Park?',
            msg_eliminar_administrador: 'Are you sure to delete the Manager?',
            msg_emergencia: 'Are you sure to send the Emergency message?',
            msg_eliminar_empleado: 'Are you sure to delete the Employee?',
            msg_eliminar_ban: 'Are you sure to delete the ban?',
            msg_eliminar_sala_espera: 'Are you sure to remove from the waiting room?',
            msg_eliminar_vigilante: 'Are you sure to delete the Guard?',
            msg_eliminar_invitacion: 'Are you sure to delete the invitation?',
            msg_cancelar_invitacion: 'Are you sure to cancel the invitation?',
            msg_eliminar_caseta: 'Are you sure to delete the Guard House?',
            msg_eliminar_invitacion_2: 'This action can not be undo.',
            mensaje_invitacion_delete: 'Invitation Removed Successfully.',
            mensaje_invitacion_canceled: 'Invitation Canceled Successfully.',
            mensaje_empleado_delete: 'Employee Removed Successfully.',
            mensaje_vigilante_delete: 'Guard Removed Successfully.',
            dias_validos: 'Valid Days',
            empresa_procedencia: 'Guest Company',
            mg_enviado: 'Message sent successfully',
            lbl_emergencia: 'Notice: An Emergency message will be sent to all guests within the Company.',
            msg: 'Message',
            recortar: 'Cut',
            recortar_imagen: 'Crop Image',
            frente: 'Front',
            reverso: 'Back',
            msg_no_days: 'You must select at least one day to continue with the Invitation.',
            msg_no_days2: 'You must select at least one day to continue.',
            cambiar_permisos: 'Change Permissions',
            move_up: 'User -> Employee',
            move_up_admin: 'User -> Manager',
            move_up_supplier: 'User -> Company Manager',
            usuarios: 'Users',
            msg_cambio_permisos: 'Permissions changed successfully.',
            msg_invitacion_confirmada: 'Confirmed Invitation Successfully.',
            msg_invitation_changed: 'Invitation Changed Successfully.',
            asistira: 'Will attend?',
            print_name_tag: 'Print name tag',
            ejemplo: 'Example: ',
            codigo_pais: 'Country Code',
            cellphone_wrong: 'Wrong Cellphone Number.',
            campany_data: 'Company Data',
            manager_data: 'Manager Data',
            employee_data: 'Employee Data',
            paso: 'Step',
            continuar: 'Continue',
            msg_cambio_password: 'Password changed Successfully.',
            configuracion: 'Settings',
            proveedor: 'Manager [Supplier]',
            empleado_proveedor: 'Employee [Supplier]',
            proveedores: 'Companies',
            Anadirproveedor: 'Add Company',
            enviar_reg_admin_proveedor: 'Email Sent Successfully.',
            msg_proveedor_correcto: 'Please verify that your information is correct. Otherwise modify them.',
            msg_empresa_proveedor: 'Your Company now uses Intrare.',
            msg_empresa_proveedor1: 'Your Company can forward invitations, manage areas and employees.',
            msg_empresa_proveedor2: 'Check your email, we have sent your credentials of access to the System.',
            catalogos: 'Catalogs',
            company_email: 'Company E-Mail',
            msg_acceso: 'Notify Access to the Guard',
            msg_acceso_exito: 'Notification Sent Successfully.',
            notificar: 'Notify',
            acciones: 'Actions',
            select_video_device: 'Select Video Device',
            msg_captura_foto: 'Click on the video to capture the image.',
            comentarios: 'Comments',
            salida_exitosa: 'Check-out Registered Successfully.',
            sin_comentarios: 'No comment',
            formato_fecha: 'DD/MM/YYYY',
            recibidos: 'Inbox',
            enviados: 'Sent',
            accesos_sin_codigo: 'Access No Code',
            msg_invitation_01: 'You have received an invitation from the Industrial Park',
            msg_invitation_02: 'Just show the following code in the gatehouse',
            msg_invitation_company_01: 'You have received an invitation from the Company',
            codigo: 'Code',
            msg_confirm_assistance: 'By confirming, you accept the requirements set by the host company.',
            msg_files_necessary_attend_invitation: 'Files necessary to attend the invitation: ',
            confirmar_asistencia: 'Confirm assistance',
            confirmed_assistance: 'CONFIRMED ASSISTANCE',
            ubicacion_maps: 'Location on Google Maps',
            msg_no_permission: 'You do not have permission to complete this invitation.',
            msg_access_no_code: 'Capture the photo of the guest\'s face or the front of an official identification, as well as the other required data.',
            msg_must_capture_photo: 'You must capture the photo before sending the data.',
            msg_no_manager_found: 'It is not possible to make the Business invitation, because an Administrator of that Company was not found. This may be because the Administrator of that Company has not been assigned or has been removed.',
            headerInvitationRecivedCompany: 'Report of Invitations Received to Companies',
            headerInvitationRecivedCompanyExcel: 'InvitationsReceived(Companies)',
            headerInvitationRecivedPark: 'Report of Invitations Received to Industrial Park',
            headerInvitationRecivedParkExcel: 'InvitationsReceived(Park)',
            headerInvitationSent: 'Report of Invitations Sent',
            headerInvitationSentExcel: 'InvitationsSent',
            headerAccess: 'Report of Access',
            headerAccessExcel: 'Access with Code',
            headerAccessNoCode: 'Report of Access No Code',
            headerAccessNoCodeExcel: 'AccessNoCode',
            period: 'Period: ',
            period2: 'Period',
            page: 'Page ',
            al: ' to ',
            de: ' of ',
            export_to_excel: 'Export to Excel',
            export_to_pdf: 'Export to PDF',
            download_to_excel: 'Download Excel',
            download_to_pdf: 'Download PDF',
            reportes: 'Reports',
            notificaciones: 'Notifications',
            canSendEmail: 'Do you want to receive emails?',
            canSendSMS: 'Do you want to receive SMS?',
            notificacion_success: 'Settings Updated Successfully.',
            activar_desactivar: 'Enable/Disable',
            activar: 'Enable',
            desactivar: 'Disable',
            note_disable_main_resident: 'Note: By deactivating the Company, the Employees, Guards and Managers of this Company will be deactivated and will not be able to Log In.',
            note_enable_main_resident: 'Note: By activating the Company, the Employees, Guards and Managers of this Company are activated.',
            msg_enable_main_resident: 'Are you sure to enable the Company?',
            msg_disable_main_resident: 'Are you sure to disable the Company?',
            note_disable_invitation_company: 'Note: By disabling Company Invitations, Company Employees and Administrators will no longer be able to make invitations.',
            note_enable_invitation_company: 'Note: By activating Company Invitations, Company Employees and Administrators will be able to make invitations.',
            msg_enable_invitation_company: 'Are you sure to Activate Company Invitations?',
            msg_disable_invitation_company: 'Are you sure to Deactivate Company Invitations?',
            mensaje_users_activados: 'Users enabled successfully.',
            mensaje_users_desactivados: 'Users disabled successfully.',
            grados: 'Rotate',
            fecha_hora_envio: 'Date and time sent',
            invEmpRecurrentes: 'Recurrent Enterprise Invitations',
            cambiar_empleado_asignado: 'Change Assigned Employee',
            msg_fotos: 'Please take the photo using the device in a vertical position.',
            msg_preregistro: 'Note: Make sure you complete all the fields correctly, as well as attach all the photos that are requested.',
            msg_current_employee: 'Currently this invitation is assigned to the Employee:',
            msg_current_employee2: 'Then select another.',
            files: 'Files',
            file: 'File',
            title_files: 'Files attached to invitations',
            display_name: 'Display name',
            add_file: 'Add File',
            msg_file_added: 'File Added Successfully.',
            msg_file_update: 'File Modified Successfully.',
            msg_file_delete: 'File Deleted Successfully.',
            msg_eliminar_file: 'Are you sure to delete the File?',
            change_file: 'Change File',
            msg_oversized: 'File size must be less than 1MB',
            mostrar: "Show",
            tooltip_help: "Report an issue",
            search_by_many_fields: 'Search by First Name, Last Name, Cell phone or E-Mail',
            msg_upgrade_user_provider_from_register_user: 'Request Sent Successfully.',
            attemps: 'Attemps available',
            num_piso: 'Floor number',
            access_code: 'Access code',
            show_floors: 'Show floor(s)',
            add_floor: 'Add floor',
            delete_floor: 'Delete floor',
            change_floor: 'Change floor',
            msg_floor_added: 'Floor Added Successfully.',
            msg_floor_update: 'Floor Modified Successfully.',
            msg_floor_delete: 'Floor Deleted Successfully.',
            msg_no_floors: 'Currently the industrial park does not have registered floors.',
            floors_park: 'Floor(s) By Park',
            access_code_elevator: 'Access Code Elevator',
            by_SMS: 'by SMS',
            msg_success_sms: 'SMS Message Sent Successfully',
            servicio_suspendido: 'Suspended Service.',
            msg_supendido: 'This message is displayed for any of the following 2 reasons:',
            msg_supendido1: 'Because you do not have permission to send invitations or',
            msg_supendido2: 'Due to non-payment, the invitation service has been suspended',
            msg_supendido3: 'For more information contact your Administrator or Intrare Provider.',
            msg_invitation_yourself: 'You can\'t send an invitation to yourself.',
            msg_invitation_user_disabled: 'I can\'t send an invitation to deactivated users.',
            title_elevator_access_days: 'Elevator access days.',
            msg1_elevator_access_days: 'Select the days to access the elevator.',
            msg2_elevator_access_days: 'Note: Only for corporate buildings that have modules installed in their Elevators.',
            msg_support: 'For any question, suggestion and/or clarification, contact us at help@intrare.app',
            current_invitations: 'Current invitations',
            copy_qr_code: 'Copy QR code',
            copy_qr_code_successfully: 'QR code copied successfully.',
            automatic_invitation: 'Automatic invitation',
            msg_automatic_subject: 'Invitation generated by the guard from guardhouse.',
            assigned: 'Assigned',
            assigned_registered: 'Assigned registered',
            deny_access: 'Deny access',
            authorized_access: 'Authorized access',
            authorize_access: 'Authorize access',
            authorize: 'Authorize access',
            send_and_notify_host_access: 'Send and Notify host access',
            your_guest: 'Your guest',
            the_person: 'The person',
            has_arrived: 'has arrived.',
            select_reason: 'Select a reason: ',
            inappropriate_behavior: 'Inappropriate behavior',
            lack_equipment: 'Lack of equipment',
            inconvenient_state_health: 'Inconvenient state of health',
            high_temperature: 'High/low temperature',
            inconsistent_false_data: 'Inconsistent and/or false data',
            msg_host_notified_correctly: 'The host was notified successfully.',
            deny: 'Denied',
            msg_invitation_registered_denied: 'ACCESS DENIED!. Access denied for the following reason: ',
            lider_area: 'Team leader',
            lbl_position: 'Position in the Company',
            position: 'Position',
            comments: 'Comments',
            add_comments: 'Add comments',
            add_comments_success: 'Comments added successfully',
            msg_only_edit_comments: 'Note: Only administrators can edit comments.',
            placas: 'License plate',
            agregar_placas: 'Add license plate',
            take_photo: 'Take a photo',
            placas_alta: 'License plate Registered Successfully.',
            placas_mostrar: 'Show license plate',
            ban_user: 'Ban access',
            remove_ban: 'Remove ban',
            user_banned: 'Banned user.',
            undefined: 'Undefined',
            reason: 'Reason: ',
            reason2: 'Reason: ',
            select_type_ban: 'Select the type of ban:',
            type_ban: 'Type of ban',
            banned_people: 'Banned people',
            show_reasons: 'Show reasons',
            veto_removed_successfully: 'Ban removed successfully.',
            msg_veto00: ' For any questions, contact the internal System Administrator.',
            msg_survey00: 'In order to access the facilities, it is necessary for the guest to complete the COVID Survey.',
            msg_survey01: 'The Guest has not answered the COVID Survey.',
            msg_survey: 'Note: Survey has been sent to you automatically.',
            header_survey: 'COVID 19 survey',
            top1_survey: 'Derived from the COVID-19 Pandemic, measures have been implemented that help us protect our entire community, based on current recommendations from the World Health Organization and the Centers for Disease Control and Prevention.',
            top2_survey: 'To prevent the spread of COVID-19 and reduce the potential risk of exposure, you are requested to respond to a screening test by completing this questionnaire upon entering the facility.',
            below_survey: 'Any questions please make it to your host or staff who give you attention in the access control of the company.',
            msg_below_survey: 'Together we prevent and advance!',
            question1: '1) In the past 14 days, have you experienced any cold or flu symptoms?',
            question2: '2) In the last 14 days, have you received a confirmed diagnosis of coronavirus (COVID-19)?',
            question3: '3) In the last 14 days, have you had contact or cared for someone diagnosed with COVID-19?',
            question4: '4) Have you traveled in the last 14 days?',
            temperature: 'Temperature',
            answer: 'Answer',
            msg_error_survey: 'In order to continue, it is necessary to mark No to all questions.',
            instructions: 'Instructions',
            instructions_to_display: 'Instructions to display',
            share_with: "Share with: ",
            shared: "Shared",
            multiple_accesses: "Multiple accesses per day",
            msg_multiple_accesses: "You can access the Company multiple times per day with this code.",
            caseta_in: "Guard House Check-in",
            caseta_out: "Guard House Check-out",
            control_number: "Control number",
            type_employee: "Type of employee",
            current: 'Current',
            canceled: 'Canceled',
            employee_number: "Employee number",
            msg_user_validated: "Guest Validated Successfully.",
            msg_user_invalidated: "A notification has been sent to your guest to correct their data.",
            validar: "Validate",
            msg_guest_corrections: "Note: If you select Yes, the guest will be notified to make the necessary corrections to their registration.",
            msg_no_register_provider_yet1: "This user has not completed",
            msg_no_register_provider_yet2: "registration as a provider.",
            registrar_usuario: 'Register user',
            registrado: "Registered",
            no_registrado: "Unregistered",
            send_waiting_room: 'Send to waiting room',
            add_carrier_data: 'Add transport data',
            carrier_data: 'Transport data',
            show_carrier_data: 'Show transport data',
            case_plates: 'Unity plates',
            container_platform_plates: 'Container/platform plates',
            transport_line: 'Transport line',
            supplier_customer_name: 'Supplier/Customer name',
            load: 'Load',
            download: 'Download',
            at_least_one_data: "Must capture at least one data.",
            data_added_successfully: "Data added successfully.",
            data_update_successfully: "Data updated successfully.",
            guardhouse_name_checkin: 'Guardhouse Check-In',
            guardhouse_name_checkout: 'Guardhouse Check-Out',
            enable_tolerance_week_invitations: 'Tolerance Enable',
            msg_enable_tolerance_week_invitations: 'Enable one-week tolerance for invitations.',
            full_msg_enable_tolerance_week_invitations: 'Allow guests to use the individual invitation with a ' +
                ' tolerance of +/- 7 days from the assigned date.',
            force_access: 'Force access',
            msg_out_date_within_tolerance: 'This invitation is out of date. However, it is within tolerance of +/- 7 days..',
            // Trajadores
            fecha_inicial: 'Initial date',
            check_in_time: 'Check in time',
            check_out_time: 'Check out time',
            worker: 'Contractor',
            workers: 'Contractors',
            add_worker: 'Add Contractor',
            msg_worker_added: 'Contractor Added Successfully.',
            msg_worker_update: 'Contractor Modified Successfully.',
            msg_worker_deleted: 'Contractor Removed Successfully.',
            msg_delete_worker: 'Are you sure to remove the Contractor?',
            show_qr_code: 'Show QR code',
            msg_accion_deshacer: 'This action cannot be undone.',
            access_days: 'Access days',
            no_records_yet: 'No records yet.',
            display_info_print: 'Display information to print',
            generate_pdf_printing: 'Generate PDF for printing',
            number_cards_sheet: 'Number of cards per sheet',
            msg_record_deleted: 'Record deleted successfully.',
            clients: 'Clients',
            add_client: 'Add Client',
            client_name: 'Client Name',
            client_number: 'Client Number',
            loading_time: 'Loading time',
            client_email: 'Client E-Mail',
            client_phone: 'Client Phone',
            client_address: 'Client Address',
            client_data: 'Client Data',
            client_data_added: 'Client Data Added Successfully.',
            client_data_updated: 'Client Data Updated Successfully.',
            client_data_deleted: 'Client Data Deleted Successfully.',
            msg_delete_client: 'Are you sure you want to delete the Client?',
            msg_delete_client2: 'This action cannot be undone.',
            msg_client_deleted: 'Client Deleted Successfully.',
            no_records_clients: 'There are no clients records.',
            landing_area: 'Landing Area',
            type_landing_area: 'Type Landing Area',
            add_landing_area: 'Add Landing Area',
            msg_landing_area: 'Landing Area added successfully.',
            msg_landing_area_updated: 'Landing Area updated successfully.',
            msg_landing_area_deleted: 'Landing Area deleted successfully.',
            msg_delete_landing_area: 'Are you sure you want to delete the Landing Area?',
            no_records_landing_area: 'There are no records of loading areas.',
            shipments: 'Shipments',
            types_of_transport: 'Types of Transport',
            add_type_transport: 'Add Type of Transport',
            type_transport: 'Type of Transport',
            msg_type_transport: 'Type of Transport added successfully.',
            msg_type_transport_updated: 'Type of Transport updated successfully.',
            msg_delete_type_transport: 'Are you sure you want to delete the Type of Transport?',
            msg_type_transport_deleted: 'Type of Transport deleted successfully.',
            no_records_type_transports: 'There are no records of Transport Types.',
            msg_no_type_transport: 'Currently there are no types of transport registered.',
            descriptionss: 'Description',
            attachments_for_the_invitation: 'Attachments for the invitation',
            attachment: 'attachment',
            add_attachment: 'Add attachment',
            msg_attachment_added: 'Attachment added successfully.',
            msg_attachment_updated: 'Attachment updated successfully.',
            msg_attachment_deleted: 'Attachment deleted successfully.',
            msg_delete_attachment: 'Are you sure you want to delete the attachment?',
            msg_no_attachments: 'Currently there are no attachments registered.',
            msg_attachment_table: 'Files attached to the form of the invitation',
            msg_documentation_completed: 'You have already uploaded all the required documents for the invitation.',
            msg_application_submitted_successfully: 'Application submitted successfully.',
            access_to_tutors: 'Access to tutors',
            parking: 'Parking',
            parking_lot: 'Parking lot',
            check_parking_availability: 'Check parking availability',
            parking_section: 'Parking Section',
            parking_space: 'Parking Space',
            assigned_parking_spaces: 'Assigned Parking Spaces',
            assigned_parking_space: 'Assigned Parking Space',
            add_parking_space: 'Add parking space',
            msg_parking_space_added: 'Parking space added successfully.',
            msg_parking_space_updated: 'Parking space updated successfully.',
            msg_parking_space_deleted: 'Parking space deleted successfully.',
            msg_delete_parking_space: 'Are you sure you want to delete the parking space?',
            msg_no_parking_space: 'Currently there are no parking spaces registered.',
            vehicle_type: 'Vehicle Type',
            vehicle_types: 'Vehicle Types',
            add_vehicle_type: 'Add Vehicle Type',
            msg_vehicle_type_added: 'Vehicle Type added successfully.',
            msg_vehicle_type_updated: 'Vehicle Type updated successfully.',
            msg_vehicle_type_deleted: 'Vehicle Type deleted successfully.',
            msg_delete_vehicle_type: 'Are you sure you want to delete the Vehicle Type?',
            msg_no_vehicle_type: 'Currently there are no Vehicle Types registered.',
            form_register_title: 'Form Register',
            register: 'Register',
            validity: 'Validity',
            no_spaces_available: 'Currently, all reserved spaces are occupied.',
            access_history_parking: 'Access History Parking',
            access_parking: 'Access Parking',
            info_shipment: 'Shipment Information',
            info_conductor: 'Driver Information',
            shipment_details: 'Shipment Details',
            shipments_supervisor: 'Shipment Supervisor',
            security_supervisor: 'Security Supervisor',
            shipping_analyst: 'Shipping Analyst',
            supervise_shipments: 'Supervise shipments',
            informative_shipments: 'Informative shipments',
            identification_documents: 'Identification Documents',
            transport_type: 'Transport Type',
            confirmed: 'Confirmed',
            not_confirmed: 'Not Confirmed',
            authorized: 'Authorized',
            arrival_registered: 'Entry Registered',
            registrar_arribo: 'Register Entry',
            mensaje_alta_arribo: 'Entry Registered Successfully.',
            loading_area: 'Loading Area',
            client_label: 'Client',
            access_history_shipments: 'Access History Shipment',
            access_shipments: 'Access Shipment',
            manage_companies: 'Manage Companies',
            has_certification_text: 'Has Certification Text?',
            view_attached_documents: 'View Attached Documents',
            confirmar_seleccion: 'Confirm Selection',
            // OCR Rules
            active_status: 'Active Status',
            valid_rfc_format: 'Valid RFC Format',
            valid_curp_format: 'Valid CURP Format',
            identity_match: 'Identity Match',
            positive_result: 'Positive Opinion',
            is_current: 'Validity',
            verification_result: 'Verification Result',
            invitar_empresa_externa: 'Invite External Company',
            nombre_empresa: 'Company Name',
            nombre_contacto: 'Contact Name',
            correo_contacto: 'Contact Email',
            empresa_existente: 'Existing company',
            empresa_no_registrada: 'Unregistered company',
            buscar_empresa: 'Search company',
            escriba_para_buscar: 'Type to search...',
            complete_campos_requeridos: 'Please complete all required fields.',
            maxium_capacity_examples: 'Examples: 100, 200, 300',
            maxium_capacity: 'Maximum capacity in the company',
            rrhh: 'Human Resources',
            management_permits: 'Management Permits',
            photographs_and_identification: 'Photographs and Identification',
            invitation_rejected: 'You have rejected the invitation.',
            security_company: 'Security Company',
            security_total_active_shifts: 'Total Active Shifts',
            security_pending_contracts: 'Pending Contracts',
            security_pending: 'Pending',
            // Park Linking Flow
            security_pending_park_contracts: 'Park Linking Contracts',
            security_pending_park_contracts_description: 'Requests for security companies to link to your parks',
            security_requests_pending: 'Pending Requests',
            security_review_and_respond: 'Review and respond to the linking request',
            security_reject: 'Reject',
            security_approve: 'Approve',
            security_no_pending_contracts: 'No pending linking requests',
            security_no_contracts_message: 'No pending linking requests at this time',
            security_no_contracts_description: 'All contracts are resolved',
            security_confirm_approve: 'Confirm Approval',
            security_confirm_reject: 'Confirm Rejection',
            security_contract_approved: 'Contract approved successfully',
            security_contract_rejected: 'Contract rejected successfully',
            error_responding_to_contract: 'Error responding to contract',
            error_fetching_contracts: 'Error fetching pending contracts',
            error_park_not_found: 'Park not found',
            error_permission_denied: 'You do not have permission to access this park',
            security_linking_request_label: 'Linking Request',
            park_name: 'Park Name',
            requested_at: 'Requested on',
            security_my_parks: 'My Linked Parks',
            security_my_parks_description: 'Parks where your security company is linked',
            security_total_parks: 'Total Parks',
            security_assign_guards_to_park: 'Assign Guards to Park',
            security_guard_assigned_to_park: 'Guard assigned to park successfully',
            security_unlink_park: 'Unlink Park',
            security_unlink_park_success: 'Park unlinked successfully',
            security_unlink_park_confirmation: 'Are you sure you want to unlink this park? Assigned guards will be unassigned and active shifts will be closed.',
            status_pending: 'Pending',
            status_active: 'Active',
            status_rejected: 'Rejected',
            security_link_new_park: 'Link New Park',
            security_pending_approval: 'This linking is pending approval by the park administrator',
            security_assign_guards: 'Assign Guards',
            security_unlink: 'Unlink',
            security_no_parks_linked: 'No linked parks',
            security_link_park_now: 'Link Park Now',
            security_confirm_unlink_park: 'Confirm Unlinking',
            confirm_unlink_park_msg: 'Are you sure you want to unlink',
            security_unlink_warning: 'Warning: Guards assigned to this park will be unassigned and active shifts will be closed.',
            security_park_unlinked_success: 'Park unlinked successfully',
            security_available_parks: 'Available Parks to Link',
            security_available_parks_description: 'Parks where you can send a linking request',
            security_send_linking_request: 'Send Request',
            security_linking_request_sent: 'Linking request sent successfully. Waiting for park administrator approval.',
            security_no_active_contracts: 'No active contracts at this time',
            security_no_active_guards: 'No active guards in caseta',
            security_company: 'Security Company',
            security_module: 'Security Module',
            security_new_contract: 'No Contract',
            security_contract_pending: 'Pending Request',
            security_contract_active: 'Linked',
            security_contract_rejected: 'Rejected',
            security_patrimonial_menu: 'Patrimonial Security',
            security_geofences: 'Geofences',
            security_geofences_description: 'Draw your company or park perimeter to define the security area',
            security_geofences_new: 'New Geofence',
            security_geofences_drawing_hint: 'Click on the map to add points to the perimeter',
            security_geofences_points_count: 'Points: {count}',
            security_geofences_undo_point: 'Undo last point',
            security_geofences_cancel_drawing: 'Cancel',
            security_geofences_finish_drawing: 'Finish and Save',
            security_geofences_min_points: 'You need at least 3 points to form a polygon',
            security_geofences_name: 'Geofence name',
            security_geofences_name_required: 'Name is required',
            security_geofences_description_field: 'Description (optional)',
            security_geofences_save: 'Save Geofence',
            security_geofences_created_success: 'Geofence created successfully',
            security_geofences_error_creating: 'Error creating geofence',
            security_geofences_error_fetching: 'Error fetching geofences',
            security_geofences_empty: "You haven't uploaded any geofence yet",
            security_geofences_delete_confirm_title: 'Delete Geofence',
            security_geofences_delete_confirm_msg: 'Are you sure you want to delete geofence',
            security_geofences_deleted_success: 'Geofence deleted successfully',
            security_geofences_error_deleting: 'Error deleting geofence',
            security_geofences_toggle_active_success: 'Geofence status updated',
            security_geofences_error_updating: 'Error updating geofence',
            security_geofences_active: 'Active',
            security_geofences_inactive: 'Inactive',
            security_geofences_locate_me: 'Locate me on the map',
            security_rounds: 'Patrol Rounds',
            security_rounds_start: 'Start Round',
            security_rounds_select_geocerca: 'Select the perimeter to patrol',
            security_rounds_no_geocercas: 'No geofences available to patrol. Contact your administrator.',
            security_rounds_checkpoints_visited: 'checkpoints visited',
            security_rounds_checkpoints: 'Checkpoints',
            security_rounds_visited_at: 'Visited at',
            security_rounds_outside_geofence: 'Outside the perimeter',
            security_rounds_capture_photo: 'Take Photo',
            security_rounds_retake_photo: 'Retake Photo',
            security_rounds_camera_error: 'Could not access the camera. Check your browser permissions.',
            security_rounds_gps_error: 'Could not get your GPS location. Enable location permission.',
            security_rounds_visit_notes: 'Notes (optional)',
            security_rounds_send_visit: 'Register Visit',
            security_rounds_visit_registered: 'Visit registered successfully',
            security_rounds_error_registering: 'Error registering checkpoint visit',
            security_rounds_error_starting: 'Error starting the round',
            security_rounds_complete: 'Complete Round',
            security_rounds_incomplete_warning: 'There are still unvisited checkpoints. Do you want to complete the round anyway?',
            security_rounds_final_notes: 'Final notes',
            security_rounds_completed_success: 'Round completed successfully',
            security_rounds_error_completing: 'Error completing the round',
            security_rounds_history: 'Rounds History',
            security_rounds_no_history: "You don't have any rounds recorded yet",
            security_rounds_no_visits: 'No checkpoints visited in this round',
            security_rounds_in_progress: 'In progress',
            security_checkpoints_title: 'Checkpoints',
            security_checkpoints_add: 'Add Checkpoint',
            security_checkpoints_hint: 'Click on the map, inside the perimeter, to place the checkpoint',
            security_checkpoints_name: 'Checkpoint name',
            security_checkpoints_name_required: 'Name is required',
            security_checkpoints_radius: 'Coverage radius (meters)',
            security_checkpoints_radius_hint: 'Minimum 10 meters',
            security_checkpoints_radius_error: 'The radius must be at least 10 meters',
            security_checkpoints_order: 'Order in the route',
            security_checkpoints_save: 'Save Checkpoint',
            security_checkpoints_radius_label: 'Radius',
            security_checkpoints_created_success: 'Checkpoint created successfully',
            security_checkpoints_error_creating: 'Error creating checkpoint',
            security_checkpoints_empty: 'This geofence has no checkpoints yet',
            direccion: 'Address',
            error_creating_guard: 'Error creating guard.',
            error_assigning_guard: 'Error assigning guard.',
            error_deleting_guard: 'Error deleting guard.',
            error_unassigning_guard: 'Error unassigning guard.',
            security_available_guards: 'Available Guards',
            assigned_park: 'Assigned Park',
            assigned_company: 'Assigned Company',
            available: 'Available',
            active: 'Active',
            inactive: 'Inactive',
            security_assign: 'Assign',
            security_unassign: 'Unassign',
            security_no_guards_available: 'No guards available',
            security_guard_unassigned_success: 'Guard unassigned successfully',
            security_select_park_description: 'Select the park you want to link your company to',
            security_select_park: 'Select a Park',
            security_send_request: 'Send Request',
            security_select_park_first: 'Select a park first',
            security_link_company: 'Link Security Company',
            security_link_company_description: 'Manage the linking of your security company with parks',
            security_active_contract: 'Active Contract',
            contact_email: 'Contact Email',
            security_unlink_company: 'Unlink Company',
            security_available_companies: 'Available Companies',
            select: 'Select',
            security_no_available_companies: 'No available companies',
            security_confirm_link: 'Confirm Linking',
            confirm_link_msg: 'Do you confirm that you want to link your company to this park?',
            confirm: 'Confirm',
            security_confirm_unlink: 'Confirm Unlinking',
            confirm_unlink_msg: 'Are you sure you want to unlink your company from this park?',
            unlink: 'Unlink',
            security_company_linked_success: 'Company linked successfully',
            crear_empleado: 'Create Employee',
            general_information: 'General Information',
            company_information: 'Company Information',
            contact_information: 'Contact Information',
            documentation: 'Documentation',
            //Vehicle Details
            detalles_vehiculo: 'Vehicle Details',
            placa_vehiculo: 'License Plate',
            marca: 'Brand',
            modelo: 'Model',
            color: 'Color',
            propietario: 'Owner',
            telefono: 'Phone',
            pesajes: 'Weighings',
            peso_entrada: 'Entry weight',
            peso_salida: 'Exit weight',
            peso_neto: 'Net weight',
            tons_to_ship: 'Tons to ship',
            branch_transfer_tons: 'Branch transfer tons',
            registrar_pesaje: 'Register weighing',
            mensaje_alta_pesaje: 'Weighing registered successfully.',
            historial_pesajes: 'Weighing history',
            no_historial_pesajes: 'There are no weighing records for this vehicle.',
            // Export parking access
            tipo_acceso_transportista: 'Access Type',
            transportista_nombre: 'Carrier Name',
            transportista_apellido: 'Carrier Last Name',
            telefono_transportista: 'Phone',
            vehiculo: 'Vehicle',
            exportar_pdf: 'Export PDF',
            exportar_excel: 'Export Excel',
            invitacion_rechazada: 'Invitation rejected',
            // Authorize Access
            autorizar_acceso: 'Authorize Access',
            acceso_no_encontrado: 'Access not found',
            no_autorizado: 'Unauthorized',
            error_cargar_acceso: 'Error loading access',
            confirmar_autorizar_acceso: 'Are you sure you want to authorize this access?',
            acceso_autorizado: 'Access authorized successfully',
            error_autorizar_acceso: 'Error authorizing access',
            confirmar_rechazar_acceso: 'Are you sure you want to reject this access?',
            error_rechazar_acceso: 'Error rejecting access',
            volver: 'Back',
            del: 'of',
            error: 'Error',
            cargando: 'Loading',
            reintentar: 'Retry',
            no_acciones_disponibles: 'No actions available for this access',
            no_tiene_permisos: 'You do not have permission to perform this action',
            confirmada: 'Confirmed',
            veces_utilizada: 'Times used',
            rechazar: 'Reject',
            invitado: 'Guest',
            informacion_invitacion: 'Invitation Information',
        }
    }
})
